import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CustomName: any;
  DateString: any;
  JSON: Record<string, unknown>;
  SerialNumber: any;
  UUID: any;
  Upload: any;
  ValidString: any;
};

/** Represents the generic formats that an answer to a question might take. */
export enum AnswerFormat {
  /** Yes/No or true or false toggle. */
  Boolean = 'Boolean',
  /** Date picker */
  Date = 'Date',
  /** Date and time picker */
  DateTime = 'DateTime',
  /** Choose multiple options */
  MultiSelect = 'MultiSelect',
  /** Numeric input */
  Number = 'Number',
  /** Choose one option */
  SingleSelect = 'SingleSelect',
  /** Free text answer */
  Text = 'Text',
  /** Time picker */
  Time = 'Time'
}

/** Represents an option that can be selected as an answer to a question in the B2B product registration flow. */
export type AnswerOption = {
  __typename?: 'AnswerOption';
  /** The human-readable text that represents this option. */
  label: Scalars['String'];
  /** The underlying value that will be stored when this option is selected. */
  value: Scalars['String'];
};

/** Attachment types */
export enum AttachmentType {
  /** Product document attachment, possible file types: JPG, PNG, GIF, DOC, DOCX, PDF, TIFF */
  Document = 'DOCUMENT',
  /** Product profile image which can be from the following types: JPG, PNG or GIF */
  ProfileImage = 'PROFILE_IMAGE'
}

/** Represents a question used in the B2B product registration flow. */
export type B2BProductQuestion = {
  __typename?: 'B2BProductQuestion';
  /** The default answer value, if any. */
  default?: Maybe<Scalars['String']>;
  /** Unique code identifying the question. */
  id?: Maybe<Scalars['String']>;
  /**
   * The available options that can be selected as answers for SingleSelect and MultiSelect questions.
   * This field is only populated when the type is SingleSelect or MultiSelect, and remains null for other answer formats.
   * Each option consists of a display label and an underlying value.
   */
  options?: Maybe<Array<Maybe<AnswerOption>>>;
  /** The text of the question to be displayed. */
  question?: Maybe<Scalars['String']>;
  /** Indicates whether answering the question is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The expected answer format for this question. */
  type?: Maybe<AnswerFormat>;
};

/** Represents an answer given during the B2B product registration flow. */
export type B2BProductRegistrationAnswer = {
  /** The unique identifier/code for the question being answered. */
  id: Scalars['String'];
  /** The format/type of the answer that was provided, must match the question's expected format. */
  type?: InputMaybe<AnswerFormat>;
  /** The answer value provided for the question. The format should match the question's type. */
  value: Scalars['String'];
};

/** Type that represents the BarAndChainClassification */
export type BarAndChainClassification = {
  __typename?: 'BarAndChainClassification';
  /** The classification of the barAndChainCombination */
  classification: Scalars['String'];
};

/** Bar and Chain Combination STIHL Product Accessory */
export type BarAndChainCombination = {
  __typename?: 'BarAndChainCombination';
  /**
   * The classification of the product
   * @deprecated The classifications field is not used by the clients. Will be removed in future releases
   */
  classifications?: Maybe<Array<BarAndChainClassification>>;
  /** The Guidebar information of the product */
  guideBar: GuideBar;
  /** The materialNumber of the product */
  materialNumber: Scalars['String'];
  /** The SawChain information of the product */
  sawChain: SawChain;
};

/** The product favorite type for a bar and chain combination. */
export type BarAndChainCombinationFavorite = {
  __typename?: 'BarAndChainCombinationFavorite';
  /** The bar and chain combination data. */
  accessory: BarAndChainCombination;
  /**
   * The bar and chain combination data.
   * @deprecated This field will be removed soon. Use instead accessory.
   */
  combination: BarAndChainCombination;
  /** The product accessory favorite ID. */
  id?: Maybe<Scalars['UUID']>;
  /**
   * This flag means that this entry was previously selected by the customer, but it is not available anymore at STIHL
   * since it is not provided by the external API.
   *
   * The customer can select and obsolete entry as favorite.
   */
  isObsolete: Scalars['Boolean'];
  /** The product favorite status as described in the ProductFavoriteStatus enum. */
  status: ProductFavoriteStatus;
};

/** The input for BarAndChainCombinationFavoriteInput. */
export type BarAndChainCombinationFavoriteInput = {
  /** The material number of the bar. */
  guideBarMaterialNumber: Scalars['String'];
  /**
   * The material number of the product to which the favorite will be added.
   * @deprecated There is no need to send the product material number, since the it is discovered in the BE using the productId
   */
  productMaterialNumber?: InputMaybe<Scalars['String']>;
  /** The material number of the saw chain. */
  sawChainMaterialNumber: Scalars['String'];
};

/** The response for the sub query productAccessories#barAndChainCombination */
export type BarAndChainCombinationsResponse = {
  __typename?: 'BarAndChainCombinationsResponse';
  /**
   * The list of available bar and chain combination favorites, including
   * available bar and chain combinations, favorite and obsolete entries.
   */
  items: Array<BarAndChainCombinationFavorite>;
};

/** Type that represents a Battery */
export type Battery = {
  __typename?: 'Battery';
  /** The accessories URL for the batteries */
  accessoryUrl?: Maybe<Scalars['String']>;
  /** The article number of the battery */
  articleNumber: Scalars['String'];
  /** Details about chargers that are compatible with this battery. */
  compatibleChargers?: Maybe<Array<Maybe<ChargerDetails>>>;
  /** The imageUrl of the battery */
  imageUrl: Scalars['String'];
  /** indicates if the image behind imageUrl is a fallback image */
  isFallbackImage: Scalars['Boolean'];
  /** The material number of the battery */
  materialNumber: Scalars['String'];
  /** The product name of the battery */
  productName: Scalars['String'];
  /** The runtimes of the battery */
  runtimes: Array<BatteryRuntime>;
};

/** Represents a battery-compatible product. */
export type BatteryCompatibleProduct = {
  __typename?: 'BatteryCompatibleProduct';
  /** The unique article number associated with the product. */
  articleNumber: Scalars['String'];
  /** The URL to the e-commerce Product Detail Page (PDP). */
  callToActionUrl?: Maybe<Scalars['String']>;
  /** Battery compatible product category. */
  category?: Maybe<ProductCategory>;
  /** List of compatible batteries with this product. The list includes only the batteries owned by the customer. */
  compatibleBatteries: Array<CompatibleBattery>;
  /** Battery compatible product drive type. */
  driveType?: Maybe<ProductDriveType>;
  /** The URL to the image of the product. */
  imageUrl: Scalars['String'];
  /** The runtime (in minutes) for the lowest power level of the largest capacity product that a customer owns. */
  maxRuntime?: Maybe<Scalars['Int']>;
  /** The product name */
  productName: Scalars['String'];
};

/** Input type for filtering and retrieving products compatible with a specific set of batteries. */
export type BatteryCompatibleProductsInput = {
  /** An optional list of battery product IDs. The query will return products compatible with these batteries. */
  batteryProductIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** The maximum number of compatible products to return. */
  limit?: InputMaybe<Scalars['Int']>;
};

/** Details about the battery that is compatible with the charger */
export type BatteryDetails = {
  __typename?: 'BatteryDetails';
  /** The name of the battery. */
  batteryName: Scalars['String'];
  /** The battery material number. */
  materialNumber: Scalars['String'];
};

/** The product favorite type for a battery. */
export type BatteryFavorite = {
  __typename?: 'BatteryFavorite';
  /** The battery data. */
  accessory: Battery;
  /** The product accessory favorite ID. */
  id?: Maybe<Scalars['UUID']>;
  /**
   * This flag means that this entry was previously selected by the customer, but it is not available anymore at STIHL
   * since it is not provided by the external API.
   *
   * The customer can select and obsolete entry as favorite.
   */
  isObsolete: Scalars['Boolean'];
  /** The product favorite status as described in the ProductFavoriteStatus enum. */
  status: ProductFavoriteStatus;
};

/** The input for BatteryCombinationFavoriteInput. */
export type BatteryFavoriteInput = {
  /** The material number of the battery. */
  batteryMaterialNumber: Scalars['String'];
};

/** The response for the sub query productAccessories#batteryCombinations */
export type BatteryResponse = {
  __typename?: 'BatteryResponse';
  /**
   * The list of available battery combinations, including the available
   * battery, favorite and obsolete entries.
   */
  items: Array<BatteryFavorite>;
};

/** Type that represents a BatteryRuntime */
export type BatteryRuntime = {
  __typename?: 'BatteryRuntime';
  /** The powerLevel of the batteryRuntime */
  powerLevel?: Maybe<Scalars['Int']>;
  /** The runtime of the batteryRuntime */
  runtime?: Maybe<Scalars['Int']>;
};

/** Represents battery runtime statistics. */
export type BatteryRuntimeStats = {
  __typename?: 'BatteryRuntimeStats';
  /** The runtime provided by the highest-capacity battery owned by the user, measured in minutes. */
  baseRuntime?: Maybe<Scalars['Int']>;
  /**
   * The percentage of runtime provided by the user's highest-capacity battery
   * relative to the highest-capacity battery available, which is considered 100%.
   *
   * For example, if the highest-capacity battery available for the product provides 10 hours of runtime,
   * and the user's highest-capacity battery provides 7 hours, the `baseRuntimePercentage` would be:
   * (7 / 10) * 100 = 70%.
   */
  baseRuntimePercentage?: Maybe<Scalars['Float']>;
  /** The additional runtime gained by using this battery compared to the baseRuntime. */
  runtimeBoost?: Maybe<Scalars['Int']>;
  /** The percentage of runtime gain compared to the baseRuntime. */
  runtimeBoostPercentage?: Maybe<Scalars['Float']>;
};

/** Type that represents the Brand of a product. */
export type Brand = {
  __typename?: 'Brand';
  /** The unique identifier of the brand. */
  id: Scalars['UUID'];
  /** The name of the brand. */
  name: Scalars['String'];
};

/** Type that represents the response of the brands query. */
export type BrandsInput = {
  /** The pagination information. */
  cursor?: InputMaybe<Scalars['String']>;
  /** The list of brands. If none brand is found, the return value will be an empty array. */
  limit?: InputMaybe<Scalars['Int']>;
};

/** Type that represents the response of the brands query. */
export type BrandsResponse = {
  __typename?: 'BrandsResponse';
  /** The list of brands. If none brand is found, the return value will be an empty array. */
  items: Array<Brand>;
  /** The pagination information. */
  pageInfo: PageInfo;
};

/**
 * The care product details, which includes the details of service that is shown to the customer
 * as the service name.
 */
export type CareProduct = {
  __typename?: 'CareProduct';
  /** The service name as known by the customer. */
  name: Scalars['String'];
};

/** Type that represents a Charger */
export type Charger = {
  __typename?: 'Charger';
  /** The accessories URL for the chargers */
  accessoryUrl?: Maybe<Scalars['String']>;
  /** The article number of the charger */
  articleNumber: Scalars['String'];
  /** Details about batteries that are compatible with this charger */
  compatibleBatteries: Array<Maybe<BatteryDetails>>;
  /** The imageUrl of the charger */
  imageUrl?: Maybe<Scalars['String']>;
  /** indicates if the image behind imageUrl is a fallback image */
  isFallbackImage: Scalars['Boolean'];
  /** The material number of the charger */
  materialNumber: Scalars['String'];
  /** The product name of the charger */
  productName: Scalars['String'];
};

/** Details about the charger and its compatibility with a battery. */
export type ChargerDetails = {
  __typename?: 'ChargerDetails';
  /** The name of the charger. */
  chargerName: Scalars['String'];
  /** The charger material number. */
  materialNumber: Scalars['String'];
  /** The time, in minutes, required to fully charge the battery using this charger. */
  timeToFullCharge: Scalars['Int'];
};

/** The product favorite type for a charger. */
export type ChargerFavorite = {
  __typename?: 'ChargerFavorite';
  /** The charger data. */
  accessory: Charger;
  /** The product accessory favorite ID. */
  id?: Maybe<Scalars['UUID']>;
  /**
   * This flag means that this entry was previously selected by the customer, but it is not available anymore at STIHL
   * since it is not provided by the external API.
   *
   * The customer can select and obsolete entry as favorite.
   */
  isObsolete: Scalars['Boolean'];
  /** The product favorite status as described in the ProductFavoriteStatus enum. */
  status: ProductFavoriteStatus;
};

/** The input for ChargerFavoriteInput. */
export type ChargerFavoriteInput = {
  /** The material numbers with which this charge is compatible with. */
  batteriesMaterialNumber: Array<Scalars['String']>;
  /** The material number of the charger. */
  chargerMaterialNumber: Scalars['String'];
};

/** The response for the sub query productAccessories#chargers */
export type ChargerResponse = {
  __typename?: 'ChargerResponse';
  /** The list of chargers, including the favorites, available and obsolete entries. */
  items: Array<ChargerFavorite>;
};

/** Represents the batteries owned by the customer and that is compatible with a specific product. */
export type CompatibleBattery = {
  __typename?: 'CompatibleBattery';
  /** The battery material number */
  materialNumber: Scalars['String'];
  /** The battery name */
  productName: Scalars['String'];
};

/** Represents a battery that is compatible with a product. */
export type CompatibleProductBattery = {
  __typename?: 'CompatibleProductBattery';
  /** The URL to the e-commerce Product Detail Page (PDP). */
  callToActionUrl?: Maybe<Scalars['String']>;
  /** The battery product category */
  category?: Maybe<ProductCategory>;
  /** The URL to the image of the battery. */
  imageUrl?: Maybe<Scalars['String']>;
  /** Flag that indicates whether the battery is already owned by the user */
  isOwned: Scalars['Boolean'];
  /** The battery material number */
  materialNumber: Scalars['String'];
  /** the max runtime of the battery with the lowest powerlevel */
  maxRuntime: Scalars['Int'];
  /** The battery name */
  productName: Scalars['String'];
  /** Statistics related to the battery's runtime performance. */
  runtimeStats?: Maybe<BatteryRuntimeStats>;
};

/** Represents a list of compatible products. */
export type CompatibleProducts = {
  __typename?: 'CompatibleProducts';
  /** Retrieves a list products that are compatible with the batteries that the user already owns. */
  batteryCompatibleProducts: Array<BatteryCompatibleProduct>;
  /** Retrieves the products owned by the customer along with a list of compatible high-capacity batteries for each product. */
  productCompatibleBatteries: Array<ProductCompatibleBattery>;
};


/** Represents a list of compatible products. */
export type CompatibleProductsBatteryCompatibleProductsArgs = {
  input?: InputMaybe<BatteryCompatibleProductsInput>;
};

/** The input for CreateBarAndChainCombinationFavorite mutation. */
export type CreateBarAndChainCombinationFavoriteInput = {
  /** The bar and chain combination favorite data. */
  favorite: BarAndChainCombinationFavoriteInput;
  /** The product id in which the bar and chain combination favorite will be created. */
  productId: Scalars['UUID'];
};

/** The response for CreateBarAndChainCombinationFavorite mutation */
export type CreateBarAndChainCombinationFavoriteResponse = {
  __typename?: 'CreateBarAndChainCombinationFavoriteResponse';
  /** The created favorite bar and chain combination. */
  favorite: BarAndChainCombinationFavorite;
  /** The product id in which the bar and chain combination favorite was created. */
  productId: Scalars['UUID'];
};

/** The input for CreateBatteryCombinationFavorite mutation. */
export type CreateBatteryFavoriteInput = {
  /** The battery combination favorite data. */
  favorite: BatteryFavoriteInput;
  /** The product id in which the battery combination favorite will be created. */
  productId: Scalars['UUID'];
};

/** The response for CreateBatteryFavorite mutation */
export type CreateBatteryFavoriteResponse = {
  __typename?: 'CreateBatteryFavoriteResponse';
  /** The created favorite battery combination. */
  favorite: BatteryFavorite;
  /** The product id in which the battery favorite was created. */
  productId: Scalars['UUID'];
};

/** The input for CreateChargerFavorite mutation. */
export type CreateChargerFavoriteInput = {
  /** The charger combination favorite data. */
  favorite: ChargerFavoriteInput;
  /** The product id in which the charger favorite will be created. */
  productId: Scalars['UUID'];
};

/** The response for CreateChargerFavorite mutation */
export type CreateChargerFavoriteResponse = {
  __typename?: 'CreateChargerFavoriteResponse';
  /** The created favorite charger combination. */
  favorite: ChargerFavorite;
  /** The product id in which the charger favorite was created. */
  productId: Scalars['UUID'];
};

/** The input for CreateCuttingAttachmentFavoriteInput mutation. */
export type CreateCuttingAttachmentFavoriteInput = {
  /** The cutting attachment favorite data. */
  favorite: CuttingAttachmentFavoriteInput;
  /** The product id in which the cutting attachment favorite will be created. */
  productId: Scalars['UUID'];
};

/** The response for CreateCuttingAttachmentFavorite mutation */
export type CreateCuttingAttachmentFavoriteResponse = {
  __typename?: 'CreateCuttingAttachmentFavoriteResponse';
  /** The created favorite cutting attachment. */
  favorite: CuttingAttachmentFavorite;
  /** The product id in which the cutting attachment favorite was created. */
  productId: Scalars['UUID'];
};

/** The input data for the createProduct mutation. */
export type CreateProductInput = {
  /**
   * Answers for the questions presented during the product creation.
   * These answers correspond to the questions fetched through the unregisteredProduct query and
   * are required to complete the registration process for B2B products.
   */
  answers?: InputMaybe<ProductRegistrationAnswersInput>;
  /** The product data to be registered. */
  product: ProductToCreateInput;
  /** The STIHL ID of the product. */
  stihlId: Scalars['UUID'];
};

/** Response for createProduct mutation. */
export type CreateProductResponse = {
  __typename?: 'CreateProductResponse';
  /** The product data registered or updated. */
  product: Product;
  /** The STIHL ID of the product. */
  stihlId: Scalars['UUID'];
};

/** The input to create a new service kit favorite entry */
export type CreateServiceKitFavoriteInput = {
  /** The service kit that should be added as a favorite */
  favorite: ServiceKitFavoriteInput;
  /** The product id to create a favorite for */
  productId: Scalars['UUID'];
};

/** The response for CreateServiceKitFavorite mutation. */
export type CreateServiceKitFavoriteResponse = {
  __typename?: 'CreateServiceKitFavoriteResponse';
  /** The ServiceKit favorite. */
  favorite: ServiceKitFavorite;
  /** The product id with which the ServiceKit will be associated as a favorite. */
  productId: Scalars['UUID'];
};

/** The input for CreateSparePartFavorite mutation. */
export type CreateSparePartFavoriteInput = {
  /** The spare part favorite data. */
  favorite: SparePartFavoriteInput;
  /** The product id in which the spare part favorite will be created. */
  productId: Scalars['UUID'];
};

/** The response for CreateSparePartFavorite mutation */
export type CreateSparePartFavoriteResponse = {
  __typename?: 'CreateSparePartFavoriteResponse';
  /** The created favorite battery combination. */
  favorite: SparePartFavorite;
  /** The product id in which the battery favorite was created. */
  productId: Scalars['UUID'];
};

/** Input type for retrieving the customer next best offers recommendations. */
export type CustomerRecommendationsInput = {
  /**
   * The origin is used to provide better insights to the NBO API and better recommendations according to the request
   * source.
   */
  origin: NextBestOfferOrigin;
};

/** Cutting Attachment STIHL Product Accessory */
export type CuttingAttachment = {
  __typename?: 'CuttingAttachment';
  /** The accessories URL for the cutting attachments */
  accessoryUrl?: Maybe<Scalars['String']>;
  /** The product article number as provided by PCIS. */
  articleNumber: Scalars['String'];
  /** The cutting attachment category */
  category: Scalars['String'];
  /** Cutting attachment head name field. */
  headName?: Maybe<Scalars['String']>;
  /** The image URL for the cutting attachment */
  imageUrl: Scalars['String'];
  /** indicates if the image behind imageUrl is a fallback image */
  isFallbackImage: Scalars['Boolean'];
  /** Material number of the product */
  materialNumber: Scalars['String'];
  /** Cutting attachment metal name field. */
  metalName?: Maybe<Scalars['String']>;
  /** Product name of the cutting attachment as provided by PCIS. */
  productName: Scalars['String'];
  /**
   * This field provides the display title for a product. It defaults to the metal/head name if available,
   * otherwise uses the PCIS product name. Client applications should favor this field for the product
   * title as it optimally represents the product accessory.
   */
  productTitle: Scalars['String'];
};

/** The product favorite type for a cutting attachment. */
export type CuttingAttachmentFavorite = {
  __typename?: 'CuttingAttachmentFavorite';
  /** The cutting attachment data. */
  accessory: CuttingAttachment;
  /** The product accessory favorite ID. */
  id?: Maybe<Scalars['UUID']>;
  /**
   * This flag means that this entry was previously selected by the customer, but it is not available anymore at STIHL
   * since it is not provided by the external API.
   *
   * The customer can select and obsolete entry as favorite.
   */
  isObsolete: Scalars['Boolean'];
  /** The product favorite status as described in the ProductFavoriteStatus enum. */
  status: ProductFavoriteStatus;
};

/** The input for CuttingAttachmentFavoriteInput. */
export type CuttingAttachmentFavoriteInput = {
  /** The material number of the cutting attachment. */
  cuttingAttachmentMaterialNumber: Scalars['String'];
};

/** The response for the sub query productAccessories#cuttingAttachments */
export type CuttingAttachmentsResponse = {
  __typename?: 'CuttingAttachmentsResponse';
  /**
   * The list of the cutting attachments categories aggregated in the backend according to the
   * entries of the API response.
   * It is useful to list the results by category.
   */
  categories: Array<Scalars['String']>;
  /**
   * The list of available cutting attachment favorites, including the available
   * cutting attachments, favorite and obsolete entries.
   */
  items: Array<CuttingAttachmentFavorite>;
};

/** Input parameters to delete the product attachment */
export type DeleteProductAttachmentInput = {
  /** Product Attachment identifier */
  productAttachmentId: Scalars['UUID'];
  /** Product ID from which the product attachment belongs to */
  productId: Scalars['UUID'];
  /** STIHL ID of the user deleting the attachment */
  stihlId: Scalars['String'];
};

/** Response for delete product attachment mutation. */
export type DeleteProductAttachmentResponse = {
  __typename?: 'DeleteProductAttachmentResponse';
  /** Product Attachment identifier */
  productAttachmentId: Scalars['UUID'];
  /** Product ID from which the product attachment belongs to */
  productId: Scalars['UUID'];
};

/** The input for DeleteFavorite mutation. */
export type DeleteProductFavoriteInput = {
  /** The product favorite id to delete. */
  productFavoriteId: Scalars['UUID'];
};

/** The response for DeleteProductFavorite mutation */
export type DeleteProductFavoriteResponse = {
  __typename?: 'DeleteProductFavoriteResponse';
  /** The bar and chain combination favorite id that was deleted. */
  productFavoriteId: Scalars['UUID'];
};

/** The input data for the deleteProduct mutation. */
export type DeleteProductInput = {
  /** The ID of the product to be unregistered. */
  productId: Scalars['UUID'];
  /** The customer STIHL ID. */
  stihlId: Scalars['UUID'];
};

/** Response for the product unregistration mutation. */
export type DeleteProductResponse = {
  __typename?: 'DeleteProductResponse';
  /** The ID of the product which was unregistered. */
  productId: Scalars['UUID'];
};

/** The `EventsResponse` type represents the response of the `events` query. It currently only contains a list of TimberSports events. */
export type EventsResponse = {
  __typename?: 'EventsResponse';
  /**
   * The list of TimberSport events.
   *
   * parameters:
   * input: Optional parameters for the query to filter the results by country and limit the number of results.
   */
  timberSports: TimberSportsEvents;
};


/** The `EventsResponse` type represents the response of the `events` query. It currently only contains a list of TimberSports events. */
export type EventsResponseTimberSportsArgs = {
  input?: InputMaybe<TimberSportsInput>;
};

/** Error related to the product attachment upload process. */
export type FailedUploadProductAttachment = {
  __typename?: 'FailedUploadProductAttachment';
  /** Description of the error */
  description?: Maybe<Scalars['String']>;
  /** File name */
  filename?: Maybe<Scalars['String']>;
  /** Type of the error */
  type?: Maybe<FailedUploadProductAttachmentType>;
};

/** File validation errors related to the product attachment process */
export enum FailedUploadProductAttachmentType {
  /** Failed to save the file metadata */
  FileMetadataNotSaved = 'FILE_METADATA_NOT_SAVED',
  /** Failed to save the file in the file storage */
  FileStorageFailed = 'FILE_STORAGE_FAILED',
  /** Generic error during the file upload process */
  FileUploadFailed = 'FILE_UPLOAD_FAILED',
  /** Mime type is not allowed */
  InvalidMimetype = 'INVALID_MIMETYPE',
  /** Maximum number of files exceeded for the given attachment type. */
  TooManyFiles = 'TOO_MANY_FILES'
}

/** Type that represents a GuideBar */
export type GuideBar = {
  __typename?: 'GuideBar';
  /** The accessory URL for the bar. */
  accessoryUrl?: Maybe<Scalars['String']>;
  /** The color of the guideBar */
  color?: Maybe<Scalars['String']>;
  /** The drive link count of the guideBar */
  driveLinkCount?: Maybe<Scalars['Int']>;
  /** The groove of the guideBar in imperial units */
  grooveImperial?: Maybe<Scalars['String']>;
  /** The groove of the guideBar in metric units */
  grooveMetric?: Maybe<Scalars['String']>;
  /** The imageUrl of the guideBar */
  imageUrl: Scalars['String'];
  /** indicates if the image behind imageUrl is a fallback image */
  isFallbackImage: Scalars['Boolean'];
  /** The length of the guideBar in imperial units */
  lengthImperial?: Maybe<Scalars['String']>;
  /** The length of the guideBar in metric units */
  lengthMetric?: Maybe<Scalars['String']>;
  /** The materialNumber of the guideBar */
  materialNumber: Scalars['String'];
  /** The new name of the guideBar */
  nameNew: Scalars['String'];
  /** The previous name of the guideBar */
  namePrev?: Maybe<Scalars['String']>;
  /** The pitch of the guideBar */
  pitch?: Maybe<Scalars['String']>;
};

/** Represents a specific image variant, detailing its MIME type and the URL where it can be accessed. */
export type ImageVariant = {
  __typename?: 'ImageVariant';
  /**
   * The MIME type of the image variant, which indicates the file format.
   * Supported formats include JPG, PNG, GIF, TIFF, and WebP.
   */
  mimeType: Scalars['String'];
  /**
   * The URL to fetch the image variant. This URL points to the location where
   * the image is stored and can be accessed directly.
   */
  url: Scalars['String'];
};

/**
 * Encapsulates different types of image variants related to a product attachment,
 * including thumbnails and optimized images.
 */
export type ImageVariants = {
  __typename?: 'ImageVariants';
  /**
   * A list of optimized image variants. These variants might include different
   * formats that are optimized for various display or performance scenarios.
   */
  optimizedImages: Array<Maybe<ImageVariant>>;
  /**
   * A single image variant specifically designated as a thumbnail.
   * This is typically a smaller version of the original image intended for quick loading and preview.
   */
  thumbnail?: Maybe<ImageVariant>;
};

/** Input parameters for retrieving the interactive garden articles */
export type InteractiveGardenArticleInput = {
  /**
   * List by the specified country, otherwise it will use the country from the logged user, according
   * to the Authorization Bearer.
   */
  country?: InputMaybe<Scalars['String']>;
  /** The tags related to the season and garden care to be filtered. */
  filterTags?: InputMaybe<Array<InteractiveGardenFilter>>;
  /** The number of items to return. Defaults to 10. */
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * List by the specified locale, otherwise it will use the locale from the logged user, according
   * to the Authorization Bearer.
   */
  locale?: InputMaybe<Scalars['String']>;
  /** The number of items to skip before starting to return results. Used for pagination. */
  offset?: InputMaybe<Scalars['Int']>;
};

/** Response containing a list of interactive garden articles */
export type InteractiveGardenArticleResponse = {
  __typename?: 'InteractiveGardenArticleResponse';
  /** List of product editorial content items */
  items: Array<Maybe<ProductEditorialContent>>;
};

/** Filter options for the interactive garden articles */
export enum InteractiveGardenFilter {
  /** Articles about animal-friendly gardening */
  AnimalFriendly = 'ANIMAL_FRIENDLY',
  /** Articles about gardening in autumn */
  Autumn = 'AUTUMN',
  /** Articles about biodiversity in the garden */
  Biodiversity = 'BIODIVERSITY',
  /** Articles about cleaning garden furniture */
  FurnitureCleaning = 'FURNITURE_CLEANING',
  /** Articles about garden waste management */
  GardenWaste = 'GARDEN_WASTE',
  /** Articles about hedge maintenance */
  HedgeCare = 'HEDGE_CARE',
  /** Articles about house cleaning */
  HouseCleaning = 'HOUSE_CLEANING',
  /** Articles about lawn maintenance */
  LawnCare = 'LAWN_CARE',
  /** Articles about outdoor cleaning */
  OutdoorCleaning = 'OUTDOOR_CLEANING',
  /** Articles about gardening in spring */
  Spring = 'SPRING',
  /** Articles about gardening in summer */
  Summer = 'SUMMER',
  /** Articles about sustainable gardening */
  Sustainability = 'SUSTAINABILITY',
  /** Articles about tree maintenance */
  TreeCare = 'TREE_CARE',
  /** Articles about gardening in winter */
  Winter = 'WINTER'
}

/** Document's main data */
export type MaintenanceDocument = {
  __typename?: 'MaintenanceDocument';
  /**
   * Document's description.
   * Example: TI 001.2016 DE
   */
  documentDescription?: Maybe<Scalars['String']>;
  /**
   * Maintenance Document's ID
   * Example: TI_001_2016_01_00_02ZTI
   */
  documentId?: Maybe<Scalars['String']>;
  /**
   * Information about the document.
   * Example: "Neuer Freischneider STIHL FS 360 C-EM – Typ 4147"
   */
  documentInfoText?: Maybe<Scalars['String']>;
  /**
   * Documents links for the different file types.
   * Example:
   * [
   * {
   * type: "PDF",
   * url: "http//www.test.com/container/doc.pdf",
   * size: 123456
   * }
   * ]
   */
  documentLinks?: Maybe<Array<MaintenanceDocumentFile>>;
  /**
   * Document's validity
   * Values:
   * - DG = valid
   * - SP = invalid
   */
  documentValidity?: Maybe<Scalars['String']>;
  /**
   * Document's version
   * Example: 02
   */
  documentVersion?: Maybe<Scalars['String']>;
  /**
   * Document's type. Can be one of the following:
   * - ZAH: Hangtag
   * - ZAK: Stickers
   * - ZBA: Instruction Manual
   * - ZBB: Leaflet
   * - ZBR: Brochure
   * - ZBS: Briggs & Stratton Document
   * - ZDT: Technical Data Sheet
   * - ZEK: Illustrated Parts List Forestry
   * - ZET: Illustrated Parts List
   * - ZFB: Instruction Manual Forestry
   * - ZHB: Manual
   * - ZKT: Catalogue
   * - ZLM: Training Material
   * - ZLT: Training Poster
   * - ZPI: Product Information
   * - ZPV: Product Comparison
   * - ZRA: Workshop/Repair Manual
   * - ZRZ: Repair Times Leaflet
   * - ZTI: Technical Information Bulletin
   */
  informationProductId?: Maybe<Scalars['String']>;
  /** Material numbers of the products. */
  materialNumbers?: Maybe<Array<MaterialNumber>>;
  /**
   * Classes of the products.
   * Example:  ["MSA 120 C-BQ"]
   */
  productClasses?: Maybe<Array<ProductClass>>;
  /**
   * Publication countries of the document.
   * Example: ["DE"]
   */
  publicationCountries?: Maybe<Array<PublicationCountry>>;
  /**
   * Document's publication date.
   * Example: "2018-01-12"
   */
  publicationDate?: Maybe<Scalars['String']>;
  /**
   * Publication languages of the document.
   * Example: ["de","en"]
   */
  publicationLanguages?: Maybe<Array<PublicationLanguage>>;
};

/** Contains the information about the document file as url and document type */
export type MaintenanceDocumentFile = {
  __typename?: 'MaintenanceDocumentFile';
  /** Size of the document */
  size?: Maybe<Scalars['Int']>;
  /** Document type, can be PDF, XML */
  type: Scalars['String'];
  /** Document's file URL */
  url: Scalars['String'];
};

/** Material number object */
export type MaterialNumber = {
  __typename?: 'MaterialNumber';
  materialNumber: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** The mutation to create a bar and chain combination favorite. */
  createBarAndChainCombinationFavorite: CreateBarAndChainCombinationFavoriteResponse;
  /** The mutation to create a battery combination favorite. */
  createBatteryFavorite: CreateBatteryFavoriteResponse;
  /** The mutation to create a charger favorite. */
  createChargerFavorite: CreateChargerFavoriteResponse;
  /** The mutation to create a cutting attachment favorite. */
  createCuttingAttachmentFavorite: CreateCuttingAttachmentFavoriteResponse;
  /** Mutation to create a STIHL or NON STIHL product. */
  createProduct?: Maybe<CreateProductResponse>;
  /** The mutation to create a service kit favorite. */
  createServiceKitFavorite: CreateServiceKitFavoriteResponse;
  /** The mutation to create a spare part favorite. */
  createSparePartFavorite: CreateSparePartFavoriteResponse;
  /** Creates a new setting for the user */
  createUserSetting?: Maybe<UserSetting>;
  /** Mutation to delete a STIHL or NON STIHL product. */
  deleteProduct?: Maybe<DeleteProductResponse>;
  /** Delete the product attachment */
  deleteProductAttachment?: Maybe<DeleteProductAttachmentResponse>;
  /** The mutation to delete a product favorite and favorite agnostic. */
  deleteProductFavorite: DeleteProductFavoriteResponse;
  /** Deletes an existing setting for the user */
  deleteUserSetting?: Maybe<UserSetting>;
  /**
   * Sets the PCIS or fallback image as the default profile image for a product.
   * When this mutation is called, it sets all customer-uploaded images as non-default.
   */
  setDefaultFallbackProfileImage?: Maybe<SetDefaultFallbackProfileImageResponse>;
  /** Mutation to update a STIHL or NON STIHL product. */
  updateProduct?: Maybe<UpdateProductResponse>;
  /** Update the product attachment metadata */
  updateProductAttachment?: Maybe<UpdateProductAttachmentResponse>;
  /** Updates an existing setting for the user */
  updateUserSetting?: Maybe<UserSetting>;
  /** Upload product attachment files and create the product attachment metadata */
  uploadProductAttachments?: Maybe<UploadProductAttachmentsResponse>;
};


export type MutationCreateBarAndChainCombinationFavoriteArgs = {
  input: CreateBarAndChainCombinationFavoriteInput;
};


export type MutationCreateBatteryFavoriteArgs = {
  input: CreateBatteryFavoriteInput;
};


export type MutationCreateChargerFavoriteArgs = {
  input: CreateChargerFavoriteInput;
};


export type MutationCreateCuttingAttachmentFavoriteArgs = {
  input: CreateCuttingAttachmentFavoriteInput;
};


export type MutationCreateProductArgs = {
  input?: InputMaybe<CreateProductInput>;
};


export type MutationCreateServiceKitFavoriteArgs = {
  input: CreateServiceKitFavoriteInput;
};


export type MutationCreateSparePartFavoriteArgs = {
  input: CreateSparePartFavoriteInput;
};


export type MutationCreateUserSettingArgs = {
  userSettingCreateData: UserSettingCreateInput;
};


export type MutationDeleteProductArgs = {
  input?: InputMaybe<DeleteProductInput>;
};


export type MutationDeleteProductAttachmentArgs = {
  input?: InputMaybe<DeleteProductAttachmentInput>;
};


export type MutationDeleteProductFavoriteArgs = {
  input: DeleteProductFavoriteInput;
};


export type MutationDeleteUserSettingArgs = {
  userSettingDeleteData: UserSettingDeleteInput;
};


export type MutationSetDefaultFallbackProfileImageArgs = {
  input?: InputMaybe<SetDefaultFallbackProfileImageInput>;
};


export type MutationUpdateProductArgs = {
  input?: InputMaybe<UpdateProductInput>;
};


export type MutationUpdateProductAttachmentArgs = {
  input?: InputMaybe<UpdateProductAttachmentInput>;
};


export type MutationUpdateUserSettingArgs = {
  userSettingUpdateData: UserSettingUpdateInput;
};


export type MutationUploadProductAttachmentsArgs = {
  input?: InputMaybe<UploadProductAttachmentsInput>;
};

export type News = {
  __typename?: 'News';
  contentUrl?: Maybe<Scalars['String']>;
  date: Scalars['String'];
  headline: Scalars['String'];
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  previewText: Scalars['String'];
  tags: Array<Maybe<Scalars['String']>>;
  targetSystem: Array<Maybe<Scalars['String']>>;
};

export type NewsInput = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: Scalars['String'];
};

export type NewsResponse = {
  __typename?: 'NewsResponse';
  items: Array<News>;
};

/** Represents the details of a product that is recommended as the next best offer. */
export type NextBestOffer = {
  __typename?: 'NextBestOffer';
  /** The unique article number associated with the product. */
  articleNumber: Scalars['String'];
  /** The URL for the e-commerce Product Detail Page (PDP). */
  callToActionUrl?: Maybe<Scalars['String']>;
  /** The product category data */
  category?: Maybe<ProductCategory>;
  /** The product drive type data. */
  driveType?: Maybe<ProductDriveType>;
  /** The product image URL. */
  imageUrl?: Maybe<Scalars['String']>;
  /** The product name of the next best offer. */
  productName: Scalars['String'];
};

/** Specifies the origin requesting the next best offers recommendations. */
export enum NextBestOfferOrigin {
  /** MySTIHL mobile dashboard. */
  MystihlAppDashboard = 'MYSTIHL_APP_DASHBOARD',
  /** MySTIHL WEB dashboard page. */
  MystihlWebDashboard = 'MYSTIHL_WEB_DASHBOARD'
}

/** Groups the next best offers for each corresponding group, such as customer or other recommendation group in the future. */
export type NextBestOffers = {
  __typename?: 'NextBestOffers';
  /** Offers generated based on the logged-in customer's email. */
  customerRecommendations: Array<Maybe<NextBestOffer>>;
};


/** Groups the next best offers for each corresponding group, such as customer or other recommendation group in the future. */
export type NextBestOffersCustomerRecommendationsArgs = {
  input: CustomerRecommendationsInput;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  count: Scalars['Int'];
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
};

/** Permission for the setting for non owners */
export type Permission = {
  __typename?: 'Permission';
  delete?: Maybe<Scalars['Boolean']>;
  read?: Maybe<Scalars['Boolean']>;
  write?: Maybe<Scalars['Boolean']>;
};

export type PermissionCreateInput = {
  /** 3rd party touchpoints can delete the setting */
  delete: Scalars['Boolean'];
  /** 3rd party touchpoints can read the setting */
  read: Scalars['Boolean'];
  /** 3rd party touchpoints can update the setting */
  write: Scalars['Boolean'];
};

/** STIHL and Non STIHL product */
export type Product = {
  __typename?: 'Product';
  /** The article number is an internationally standardized number uniquely identifying a material as defined in the ERP system. */
  articleNumber?: Maybe<Scalars['String']>;
  /** Includes the attachments profile images and documents of a product. */
  attachments?: Maybe<Array<ProductAttachment>>;
  /** The brand of the product, in case of a Non STIHL product. */
  brand?: Maybe<Brand>;
  /** The certificate of authenticity PDF for this product. */
  certificateOfAuthenticity?: Maybe<MaintenanceDocumentFile>;
  /**
   * The custom name, also known as Nickname, is a customized name for the product,
   * in which the customer can provide to a product. If not informed by the customer
   * the Nickname will be randomly generated.
   */
  customName: Scalars['String'];
  /** Product's ID */
  id: Scalars['UUID'];
  /**
   * The products default image. If the product has a profile image attachment, it will get from that
   * otherwise it will use the one provided by PCIS.
   * @deprecated Deprecated. Use the productImages object, which includes this and other fields, and may be expanded in the future.
   */
  imageSrc?: Maybe<Scalars['String']>;
  /** Represents the images associated with a product, including the default product image and the STIHL product image. */
  images?: Maybe<ProductImages>;
  /**
   * Indicates that the imageSrc URL is a fallback image of the product category, originating from the product category and image mapping maintained in Contentful.
   * @deprecated Deprecated. Use the productImages object, which includes this and other fields, and may be expanded in the future.
   */
  isFallbackImage?: Maybe<Scalars['Boolean']>;
  /** Indicates whether it is still possible to claim a warranty extension for this product. */
  isWarrantyExtensionPossible?: Maybe<Scalars['Boolean']>;
  /** The material number uniquely identify a product type, meaning that it classifies uniquely a class of products. */
  materialNumber?: Maybe<Scalars['String']>;
  /**
   * The product category, applicable for both STIHL and Non STIHL products. This information
   * is provided by the PCIS in case of a STIHL product.
   */
  productCategory?: Maybe<ProductCategory>;
  /**
   * Product drive type, applicable for both STIHL and Non STIHL products. This information
   * is provided by the PCIS in case of a STIHL product.
   */
  productDriveType?: Maybe<ProductDriveType>;
  /**
   * Manuals of a product, based on the User's language and filtering the Instructions Manuals (ZBA's)
   * in the technical documentation API.
   */
  productManualFile?: Maybe<MaintenanceDocumentFile>;
  /** This is the product name, as presented in the products catalogue. For example: MS 201 C-M */
  productName?: Maybe<Scalars['String']>;
  /** The purchase date of a product. */
  purchaseDate?: Maybe<Scalars['String']>;
  /** Product registration date. */
  registrationDate: Scalars['String'];
  /** The serial number of a product. This indicates that the product is from STIHL. */
  serialNumber?: Maybe<Scalars['SerialNumber']>;
  /** The maintenance services of a product */
  serviceEntries?: Maybe<Array<ProductServiceEntry>>;
  /** ServiceReminder of a product */
  serviceReminder?: Maybe<ServiceReminder>;
  /** Status of a product */
  status: ProductStatus;
  /** The warranty end date of a product. */
  warrantyEndDate?: Maybe<Scalars['String']>;
  /** The Date on which the warranty extension was granted */
  warrantyExtensionDate?: Maybe<Scalars['String']>;
};

/** The input for productAccessories query */
export type ProductAccessoriesInput = {
  /**
   * Optional parameter to override the default behavior of using the user's profile language for translating service kit texts,
   * instead using the locale specified in the URL path.
   */
  overrideLocale?: InputMaybe<Scalars['String']>;
  /** Product ID to get the available product accessories and favorites. */
  productId: Scalars['String'];
};

/** The response for the productAccessories query. */
export type ProductAccessoriesResponse = {
  __typename?: 'ProductAccessoriesResponse';
  /**
   * The bar and chain combination entries available to be selected as a favorite. It includes the
   * current favorite and obsolete entries.
   */
  barAndChainCombinations?: Maybe<BarAndChainCombinationsResponse>;
  /**
   * The battery entries available to be selected as a favorite. It includes the
   * current favorite and obsolete entries.
   */
  batteries?: Maybe<BatteryResponse>;
  /** The charger entries available to be selected as a favorite. It includes the favorites and obsolete entries. */
  chargers?: Maybe<ChargerResponse>;
  /**
   * The cutting attachment entries available to be selected as a favorite. It includes the
   * current favorite and obsolete entries.
   */
  cuttingAttachments?: Maybe<CuttingAttachmentsResponse>;
  /** The aggregated product accessory favorites. */
  favorites?: Maybe<ProductAccessoryFavorites>;
  /**
   * Optional parameter to override the default behavior of using the user's profile language for translating service kit texts,
   * instead using the locale specified in the URL path.
   */
  overrideLocale?: Maybe<Scalars['String']>;
  /** The product ID associated with the favorites and the accessories entries. */
  productId?: Maybe<Scalars['UUID']>;
  /**
   * The service kit entries available to be selected as a favorite. It includes the
   * current favorite and obsolete entries.
   */
  serviceKits?: Maybe<ServiceKitResponse>;
  /**
   * The spare parts entries available to be selected as a favorite. It includes the
   * current favorite and obsolete entries.
   */
  spareParts?: Maybe<SparePartResponse>;
};

/** Aggregates all product accessory favorites. */
export type ProductAccessoryFavorites = {
  __typename?: 'ProductAccessoryFavorites';
  /** Bar and chain combination favorites. */
  barAndChainCombinations: Array<BarAndChainCombinationFavorite>;
  /** Battery favorites */
  batteries: Array<BatteryFavorite>;
  /** Charger favorites */
  chargers: Array<ChargerFavorite>;
  /** Cutting attachments favorites. */
  cuttingAttachments: Array<CuttingAttachmentFavorite>;
  /** Service kit favorites */
  serviceKits: Array<ServiceKitFavorite>;
  /** Spare parts favorites */
  spareParts: Array<SparePartFavorite>;
};

/** Product attachment data */
export type ProductAttachment = {
  __typename?: 'ProductAttachment';
  /** Created at date */
  createdAt: Scalars['DateString'];
  /** Defines if this element is the main profile image. This is applied only if type is PROFILE_IMAGE */
  defaultProfileImage: Scalars['Boolean'];
  /** Attachment file name, this is autogenerated by the API. It is not the original filename. */
  filename: Scalars['String'];
  /** Attachment ID */
  id: Scalars['UUID'];
  /**
   * Contains the image variants associated with this attachment, including thumbnails and optimized images.
   * This field is specifically for attachments that are images and may not be relevant for other file types.
   */
  imageVariants?: Maybe<ImageVariants>;
  /**
   * mimeType, could be one of the following:
   * - application/jpg
   * - application/png
   * - application/gif
   * - application/tiff
   * - application/pdf
   * - application/msword
   * - application/vnd.openxmlformats-officedocument.wordprocessingml.document
   */
  mimeType: Scalars['String'];
  /** Attachment original filename. */
  originalFilename: Scalars['String'];
  /** Attachment file type */
  type: AttachmentType;
  /** File URL to fetch the attachment. */
  url: Scalars['String'];
};

/** Input parameters to filter for a list of attachments of a product. */
export type ProductAttachmentsInput = {
  /** Filter for default profile if true. */
  defaultProfileImage?: InputMaybe<Scalars['Boolean']>;
  /** File mimeType, could be one of the following: JPG, PNG, GIF, DOC, DOCX, PDF, TIFF. (exact) */
  mimeType?: InputMaybe<Scalars['String']>;
  /** Attachment original filename, will filter by part of the name (contains) */
  originalFilename?: InputMaybe<Scalars['String']>;
  /** Product ID from which the product attachment belongs to */
  productId?: InputMaybe<Scalars['UUID']>;
  /** Attachment file type (exact) */
  type?: InputMaybe<AttachmentType>;
};

/** Response for the productAttachments query. */
export type ProductAttachmentsResponse = {
  __typename?: 'ProductAttachmentsResponse';
  /** List of attachments of a product. */
  attachments: Array<ProductAttachment>;
};

/** Input for the productCategories query. */
export type ProductCategoriesInput = {
  /** Pagination cursor's start. */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to return in the pagination. */
  limit?: InputMaybe<Scalars['Int']>;
};

/** The response of the product categories query, provided with pagination. */
export type ProductCategoriesResponse = {
  __typename?: 'ProductCategoriesResponse';
  /** List of product categories. */
  items: Array<ProductCategory>;
  /** Pagination information. */
  pageInfo: PageInfo;
};

/** The category of a product, for example Chainsaw, Hedge Trimmer, etc. */
export type ProductCategory = {
  __typename?: 'ProductCategory';
  /** Category group of the product category. */
  categoryGroup?: Maybe<ProductCategoryGroup>;
  /** Id of the product category. */
  id?: Maybe<Scalars['UUID']>;
  /** Name of the product category. */
  name: Scalars['String'];
};

/**
 * The category group aggregates the product categories by a specific type for example Sawing and Cutting, Gardening, etc.
 * This data is registered internally in the customer products services, it is not provided by an External STIHL service.
 */
export type ProductCategoryGroup = {
  __typename?: 'ProductCategoryGroup';
  /** Id of the category group. */
  id?: Maybe<Scalars['UUID']>;
  /** Name of the category group. */
  name: Scalars['String'];
};

/** Product class object */
export type ProductClass = {
  __typename?: 'ProductClass';
  productClass: Scalars['String'];
};

/** Represents a battery-powered product and its compatible batteries. */
export type ProductCompatibleBattery = {
  __typename?: 'ProductCompatibleBattery';
  /** The unique article number associated with the product. */
  articleNumber: Scalars['String'];
  /** The call to action url */
  callToActionUrl?: Maybe<Scalars['String']>;
  /** Product compatible with battery category. */
  category?: Maybe<ProductCategory>;
  /** List of compatible batteries with this product. The list includes only the batteries owned by the customer. */
  compatibleBatteries: Array<CompatibleProductBattery>;
  /** Product compatible with battery drive type. */
  driveType?: Maybe<ProductDriveType>;
  /** The URL to the image of the product. */
  imageUrl?: Maybe<Scalars['String']>;
  /** Flag that indicates whether the imageUrl represents a fallback image */
  isFallbackImage?: Maybe<Scalars['Boolean']>;
  /** The product name. */
  productName: Scalars['String'];
};

/** The product drive type such as Electric, Petrol, Battery, etc. */
export type ProductDriveType = {
  __typename?: 'ProductDriveType';
  /** The product drive type id. */
  id?: Maybe<Scalars['UUID']>;
  /** The name of the product drive type. */
  name: Scalars['String'];
};

/** The product drive type input. */
export type ProductDriveTypesInput = {
  /** Pagination cursor's start. */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to return in the pagination. */
  limit?: InputMaybe<Scalars['Int']>;
};

/** The product drive type response. */
export type ProductDriveTypesResponse = {
  __typename?: 'ProductDriveTypesResponse';
  /** The list of product drive types. */
  items: Array<ProductDriveType>;
  /** The page information. */
  pageInfo: PageInfo;
};

/** Product Editorial Content */
export type ProductEditorialContent = {
  __typename?: 'ProductEditorialContent';
  /** The url of the editorial content */
  contentUrl: Scalars['String'];
  /** The description of the editorial content */
  description: Scalars['String'];
  /** The alt text of the editorial content image */
  imageAltText: Scalars['String'];
  /** The image url of the editorial content. This image has a size transformer applied to it. Use rawImageUrl for the original image. */
  imageUrl: Scalars['String'];
  /** The original image url of the editorial content with no transformer applied. */
  rawImageUrl: Scalars['String'];
  /** The title of the editorial content */
  title: Scalars['String'];
};

/** Input parameters for retrieving product editorial content */
export type ProductEditorialContentInput = {
  /** The number of items to return. Defaults to unlimited. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The product types to get editorial content for */
  productTypes: Array<Scalars['String']>;
  /** The STIHL Id of the user. */
  stihlId: Scalars['UUID'];
};

/** Response containing a list of product editorial content items */
export type ProductEditorialContentResponse = {
  __typename?: 'ProductEditorialContentResponse';
  /** List of product editorial content items */
  items: Array<Maybe<ProductEditorialContent>>;
};

/** Status to indicate the different states of a product favorite. */
export enum ProductFavoriteStatus {
  /** The product favorite is active and valid */
  Active = 'ACTIVE',
  /**
   * The product favorite is inactive, meaning that the favorite was deleted by
   * the user.
   */
  Inactive = 'INACTIVE'
}

/** Represents the images associated with a product, including the default product image and the STIHL product image. */
export type ProductImages = {
  __typename?: 'ProductImages';
  /**
   * The default image can be:
   * - A user-uploaded profile image attachment
   * - A STIHL product image
   * - A fallback image
   * The logic for displaying the default image is as follows:
   * 1. Show the image that the user selected as default.
   * 2. If no image is selected by the user, show the STIHL product image.
   * 3. If the STIHL product image is not found, show the fallback image.
   */
  defaultImageUrl?: Maybe<Scalars['String']>;
  /** The product image is either the STIHL image or a fallback image if the STIHL image is not found. */
  stihlImageUrl?: Maybe<Scalars['String']>;
};

/**
 * Input for the product query.
 *
 * Note:
 * - A user can only fetch its own product.
 */
export type ProductInput = {
  /** The product id. */
  productId: Scalars['UUID'];
};

/** Input of productManual query. The material number or serial number is mandatory plus the publication language. */
export type ProductManualInput = {
  /**
   * The fallback locale is used to retrieve a fallback url for the product manual, when no manual is found in the
   * technical documentation API.
   * If the fallbackLocale is not informed it will use as default en-US.
   * The accepted format for this field is: Language code in ISO 639-1 (in lower case) combined with ISO 3166-1 alpha-2. E.g. de-DE
   */
  fallbackLocale?: InputMaybe<Scalars['String']>;
  /** Material number(s) of the product, mandatory (optional when serialNumber or productClass is specified, only one of these 3 may be specified). Can be supplied as a comma-separated list or specified multiple times. E.g. 48160114100 */
  materialNumber?: InputMaybe<Scalars['String']>;
  /** Language code in ISO 639-1 (in lower case). E.g. de */
  publicationLanguage: Scalars['String'];
  /** Serial number of the product, mandatory. E.g. 432230911 */
  serialNumber?: InputMaybe<Scalars['String']>;
};

/** Represents a question used in the product registration flow. */
export type ProductQuestion = {
  __typename?: 'ProductQuestion';
  /** The default answer value, if any. */
  default?: Maybe<Scalars['String']>;
  /** Unique code identifying the question. */
  id: Scalars['String'];
  /**
   * The available options that can be selected as answers for SingleSelect and MultiSelect questions.
   * This field is only populated when the type is SingleSelect or MultiSelect, and remains null for other answer formats.
   * Each option consists of a display label and an underlying value.
   */
  options?: Maybe<Array<Maybe<AnswerOption>>>;
  /** The text of the question to be displayed. */
  question: Scalars['String'];
  /** Indicates whether answering the question is required. */
  required: Scalars['Boolean'];
  /** The expected answer format for this question. */
  type: AnswerFormat;
};

/** Represents the response containing compatible products. */
export type ProductRecommendationsResponse = {
  __typename?: 'ProductRecommendationsResponse';
  /** Contains information about compatible products. */
  compatibleProducts?: Maybe<CompatibleProducts>;
  /** Contains the Next Best Offers product recommendations. */
  nextBestOffers?: Maybe<NextBestOffers>;
};

/** Represents an answer given during the product registration flow. */
export type ProductRegistrationAnswer = {
  /**
   * Optional additional information for the answer value.
   * Used primarily when an "Other" option is selected to provide custom details.
   */
  additionalInfo?: InputMaybe<Scalars['String']>;
  /** The unique identifier/code for the question being answered. */
  id: Scalars['String'];
  /**
   * The format/type of the answer that was provided.
   * Must match the type specified in the corresponding question.
   */
  type?: InputMaybe<AnswerFormat>;
  /**
   * The answer value provided for the question.
   * Must match the expected format based on the question's type:
   * - Text: Free text string
   * - Number: Numeric value
   * - Date: Date string in ISO format
   * - Time: Time string in ISO format
   * - DateTime: Full ISO datetime string
   * - SingleSelect: Single option value from question's options
   * - MultiSelect: Multiple option values from question's options
   * - Boolean: "true" or "false" string
   */
  value: Scalars['String'];
};

/** Interface that provides the necessary data to store the user answers for the B2B product registration process. */
export type ProductRegistrationAnswersInput = {
  /**
   * The list of answers provided by the user during B2B product registration workflow.
   * These answers correspond to the dynamic questions fetched via the unregisteredProduct query.
   * @deprecated Use the warrantyExtension field instead, which contains the B2B answers or the generic process
   */
  b2b?: InputMaybe<Array<InputMaybe<B2BProductRegistrationAnswer>>>;
  /** Answers about where and how the product was purchased. */
  purchaseSource?: InputMaybe<Array<InputMaybe<ProductRegistrationAnswer>>>;
  /**
   * Answers for the warranty extension process including B2B product registration and warranty extension.
   * At the current time, only the B2B answers are available.
   */
  warrantyExtension?: InputMaybe<Array<InputMaybe<ProductRegistrationAnswer>>>;
};

/** Represents the set of questions required for product registration. */
export type ProductRegistrationQuestions = {
  __typename?: 'ProductRegistrationQuestions';
  /**
   * List of questions used in the B2B product registration flow.
   * @deprecated Use warrantyExtension field instead which contains both B2B and warranty extension questions
   * @deprecated use the warrantyExtension field instead.
   */
  b2b?: Maybe<Array<Maybe<B2BProductQuestion>>>;
  /** Questions about where and how the product was purchased. */
  purchaseSource?: Maybe<Array<Maybe<ProductQuestion>>>;
  /**
   * Questions for the warranty extension process including B2B product registration and warranty extension.
   * At the current time, only the B2B questions are available.
   */
  warrantyExtension?: Maybe<Array<Maybe<ProductQuestion>>>;
};

/** Represents a maintenance service performed in a STIHL product. */
export type ProductServiceEntry = {
  __typename?: 'ProductServiceEntry';
  /** The ID of the dealer organization that performed the service. */
  dealerOrgId: Scalars['String'];
  /** The ID of the product service entry. */
  id: Scalars['Int'];
  /** Is the product still usable? */
  machineUsable: Scalars['Boolean'];
  /** Represents the date of the next maintenance service. */
  nextService: Scalars['String'];
  /** The serial number of the product. */
  serialNumber: Scalars['String'];
  /** Is the service still active? */
  serviceProductActive: Scalars['Boolean'];
  /** The ID of the service that was performed in the product. */
  serviceProductId: Scalars['Int'];
  /** The service title that was performed in the product. */
  serviceProductTitle: Scalars['String'];
  /** The protocol of the service. */
  serviceProtocol: ServiceProtocol;
  /** The service protocol file URI. */
  serviceProtocolFileUri: Scalars['String'];
  /** The service status */
  serviceStatus: Scalars['String'];
  /** The date and time the service was performed. */
  timestamp: Scalars['String'];
};

/**
 * Different statuses of a product. By default, when creating a STIHL product through MySTIHL,
 * it will be UNVERIFIED
 */
export enum ProductStatus {
  /** Product x Customer relationship is not verified by STIHL. This means we are not sure that the customer is the real owner of the product. */
  Unverified = 'UNVERIFIED',
  /** Product x Customer relationship is verified by other STIHL processes like the iMOW registration process. */
  Verified = 'VERIFIED'
}

/** The product data input to be registered. */
export type ProductToCreateInput = {
  /** The brand of the product, in case of a Non STIHL product. */
  brandId?: InputMaybe<Scalars['UUID']>;
  /** Product custom name, also known as Nickname. If not informed it will be randomly generated. */
  customName?: InputMaybe<Scalars['CustomName']>;
  /** The product category, applicable for Non STIHL products. */
  productCategoryId?: InputMaybe<Scalars['UUID']>;
  /** Product drive type, applicable for Non STIHL products. */
  productDriveTypeId?: InputMaybe<Scalars['UUID']>;
  /** Product name, as presented in the products catalogue. For example: MS 201 C-M. */
  productName?: InputMaybe<Scalars['ValidString']>;
  /** The purchase date of a product. */
  purchaseDate?: InputMaybe<Scalars['DateString']>;
  /** The registration date of a product in MySTIHL. */
  registrationDate?: InputMaybe<Scalars['DateString']>;
  /** The serial number in case of a STIHL product. */
  serialNumber?: InputMaybe<Scalars['SerialNumber']>;
  /** The service reminder data of a product. */
  serviceReminder?: InputMaybe<ServiceReminderToRegisterInput>;
  /** The warranty end date of a product. */
  warrantyEndDate?: InputMaybe<Scalars['DateString']>;
};

/** The product data input to be updated. */
export type ProductToUpdateInput = {
  /** The brand of the product, in case of a Non STIHL product. */
  brandId?: InputMaybe<Scalars['UUID']>;
  /** Product custom name, also known as Nickname. If not informed it will not be updated. */
  customName?: InputMaybe<Scalars['CustomName']>;
  /** Product ID to be updated. */
  id: Scalars['UUID'];
  /** The product category, applicable for both STIHL and Non STIHL products. */
  productCategoryId?: InputMaybe<Scalars['UUID']>;
  /** Product drive type, applicable for both STIHL and Non STIHL products. */
  productDriveTypeId?: InputMaybe<Scalars['UUID']>;
  /** Product name, as presented in the products catalogue. For example: MS 201 C-M. */
  productName?: InputMaybe<Scalars['ValidString']>;
  /** The purchase date of a product. */
  purchaseDate?: InputMaybe<Scalars['DateString']>;
  /** The service reminder data of a product. */
  serviceReminder?: InputMaybe<ServiceReminderToUpdateInput>;
  /** The warranty end date of a product. */
  warrantyEndDate?: InputMaybe<Scalars['DateString']>;
};

/**
 * Input for the products query.
 *
 * Note:
 * - A user can only fetch its own products.
 */
export type ProductsInput = {
  /** Cursor of the last entry so it is possible to paginate the results in a subsequent request. */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of entries to include in the response. By default it includes 10 entries. */
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * Product status to include when filtering for products.
   *
   * Notes:
   * - By default it returns products with VERIFIED and UNVERIFIED status.
   */
  status?: InputMaybe<Array<ProductStatus>>;
};

/** Response of products query. */
export type ProductsResponse = {
  __typename?: 'ProductsResponse';
  /** List of products of a user. */
  items: Array<Product>;
  /** The pagination information. */
  pageInfo: PageInfo;
};

/** Response for the findProductsToImport query. */
export type ProductsToImportResponse = {
  __typename?: 'ProductsToImportResponse';
  /** List of products which are not registered in MySTIHL */
  items: Array<UnregisteredProduct>;
};

/** Document's publication country */
export type PublicationCountry = {
  __typename?: 'PublicationCountry';
  publicationCountry: Scalars['String'];
};

/** Document's publication language */
export type PublicationLanguage = {
  __typename?: 'PublicationLanguage';
  publicationLanguage: Scalars['String'];
};

/** The `Query` type represents all of the entry points into our object graph. */
export type Query = {
  __typename?: 'Query';
  /** Query that returns a list of brands. */
  brands?: Maybe<BrandsResponse>;
  /** Returns a list of events. Currently we only support TimberSports events. */
  events?: Maybe<EventsResponse>;
  /**
   * Fetches the STIHL products for the currently logged-in user from different services that might be imported to the user's tool-shed.
   *
   * Even tho this method is somewhat in the context of the user, the correct place for it is here rather than in the user.graphql
   * since the products that are received are not yet in the scope of our system (before import)
   */
  findProductsToImport?: Maybe<ProductsToImportResponse>;
  /** Get the interactive garden content based on filter tags and pagination parameters */
  interactiveGardenArticles?: Maybe<InteractiveGardenArticleResponse>;
  news?: Maybe<NewsResponse>;
  /**
   * Returns the available product accessories including:
   * - bar and chain combination
   * - cutting attachments
   * - battery combinations
   * - service kits
   * - product favorites, only active ones.
   *
   * The response includes the current product favorites and also the obsolete entries, meaning the ones that were selected as a
   * favorite in the past but are no available in the external APIs anymore.
   */
  productAccessories: ProductAccessoriesResponse;
  /**
   * Filter and list the attachments of a product, accepting different filter inputs
   * such as type PROFILE_IMAGE or DOCUMENT, file mimeType and original name, by defaultProfileImage.
   */
  productAttachments?: Maybe<ProductAttachmentsResponse>;
  /** Query to get the product categories. */
  productCategories?: Maybe<ProductCategoriesResponse>;
  /** Query to retrieve a list of product drive types. */
  productDriveTypes?: Maybe<ProductDriveTypesResponse>;
  /** Get the editorial content for a list of product types */
  productEditorialContent?: Maybe<ProductEditorialContentResponse>;
  /**
   * Returns the latest instruction manual (ZBA) of a specific product,
   * based on the serial number and language.
   * The response includes the PDF and XML file URLs.
   *
   * No authentication required to access this service.
   */
  productManual?: Maybe<MaintenanceDocument>;
  /** Retrieves product recommendations, including information about compatible products and next best offers. */
  productRecommendations?: Maybe<ProductRecommendationsResponse>;
  /**
   * This query returns all the available bar and chain combinations of a product that might be selected as favorite.
   * Besides it also returns the selected favorite bar and chain combination and the obsolete bar and chain combinations.
   *
   * The obsolete bar and chain combinations are the ones that were selected as favorite in the past but are not available anymore
   * in the BarAndChainCombinations external API.
   * @deprecated This query is deprecated and will be removed in future releases. Please use instead selectableProductAccessories.
   */
  selectableBarAndChainFavorites: SelectableBarAndChainFavoritesResponse;
  /**
   * This query returns the data of a STIHL product which is not registered within MySTIHL Portal.
   * It checks if a given serial number already exists in the database and it is active. If it there is a product
   * already registered it throws an error, otherwise it will return the STIHL product data from PCIS and other services
   * so the user is able to continue with the registration process.
   */
  unregisteredProduct?: Maybe<UnregisteredProduct>;
  /**
   * Fetches the STIHL products for the currently logged-in user form CRM that might be migrated to the user's tool-shed.
   *
   * Even tho this method is somewhat in the context of the user, the correct place for it is here rather than in the user.graphql
   * since the products that are received are not yet in the scope of our system (before migration)
   * @deprecated This query is superseded by the findProductsToImport query.
   */
  unregisteredProductsFromCRM?: Maybe<UnregisteredProductsFromCrmResponse>;
  /**
   * Query to return the information of a user, such as:
   * - Products: List and filter the products of the logged user.
   * - Product: Return and filter one product of the logged user.
   *
   * Note:
   * - It is only possible to retrieve the information of a user, if the authenticated user is the same as the STIHL ID in the request.
   */
  user?: Maybe<User>;
  /** Returns the setting for the given name */
  userSetting?: Maybe<UserSetting>;
  /** Returns all settings for the user */
  userSettings?: Maybe<Array<Maybe<UserSetting>>>;
  /** Query to retrieve videos */
  videos?: Maybe<VideosResponse>;
};


/** The `Query` type represents all of the entry points into our object graph. */
export type QueryBrandsArgs = {
  input?: InputMaybe<BrandsInput>;
};


/** The `Query` type represents all of the entry points into our object graph. */
export type QueryInteractiveGardenArticlesArgs = {
  input?: InputMaybe<InteractiveGardenArticleInput>;
};


/** The `Query` type represents all of the entry points into our object graph. */
export type QueryNewsArgs = {
  input?: InputMaybe<NewsInput>;
};


/** The `Query` type represents all of the entry points into our object graph. */
export type QueryProductAccessoriesArgs = {
  input: ProductAccessoriesInput;
};


/** The `Query` type represents all of the entry points into our object graph. */
export type QueryProductAttachmentsArgs = {
  input?: InputMaybe<ProductAttachmentsInput>;
};


/** The `Query` type represents all of the entry points into our object graph. */
export type QueryProductCategoriesArgs = {
  input?: InputMaybe<ProductCategoriesInput>;
};


/** The `Query` type represents all of the entry points into our object graph. */
export type QueryProductDriveTypesArgs = {
  input?: InputMaybe<ProductDriveTypesInput>;
};


/** The `Query` type represents all of the entry points into our object graph. */
export type QueryProductEditorialContentArgs = {
  input?: InputMaybe<ProductEditorialContentInput>;
};


/** The `Query` type represents all of the entry points into our object graph. */
export type QueryProductManualArgs = {
  input?: InputMaybe<ProductManualInput>;
};


/** The `Query` type represents all of the entry points into our object graph. */
export type QuerySelectableBarAndChainFavoritesArgs = {
  input: SelectableBarAndChainFavoritesInput;
};


/** The `Query` type represents all of the entry points into our object graph. */
export type QueryUnregisteredProductArgs = {
  input?: InputMaybe<UnregisteredProductInput>;
};


/** The `Query` type represents all of the entry points into our object graph. */
export type QueryUserArgs = {
  input: UserInput;
};


/** The `Query` type represents all of the entry points into our object graph. */
export type QueryUserSettingArgs = {
  name: Scalars['String'];
};

/** Type that represents a SawChain */
export type SawChain = {
  __typename?: 'SawChain';
  /** The accessory URL for saw chain. */
  accessoryUrl?: Maybe<Scalars['String']>;
  /** The drive link count of the sawChain */
  driveLinkCount?: Maybe<Scalars['Int']>;
  /** The driveGauge of the sawChain in imperial units */
  driveLinkGaugeImperial?: Maybe<Scalars['String']>;
  /** The driveGauge of the sawChain in metric units */
  driveLinkGaugeMetric?: Maybe<Scalars['String']>;
  /** The imageUrl for the sawChain */
  imageUrl: Scalars['String'];
  /** indicates if the image behind imageUrl is a fallback image */
  isFallbackImage: Scalars['Boolean'];
  /** The marketingNumber of the sawChain */
  marketingNumber?: Maybe<Scalars['String']>;
  /** The materialNumber of the sawChain */
  materialNumber: Scalars['String'];
  /** The pitch of the sawChain */
  pitch?: Maybe<Scalars['String']>;
  /** The productText of the sawChain */
  productText: Scalars['String'];
  /** The productTextUS of the sawChain */
  productTextUS?: Maybe<Scalars['String']>;
  /** The sortOrder */
  sortOrder?: Maybe<Scalars['Int']>;
};

/**
 * A selectable bar and chain favorite means the entries available to be selected as a favorite,
 * including the existing favorite and the obsolete ones.
 */
export type SelectableBarAndChainFavorite = {
  __typename?: 'SelectableBarAndChainFavorite';
  /** The bar and chain combination data. */
  combination: BarAndChainCombination;
  /**
   * The bar and chain combination favorite ID. It is optional since the favorite
   * might not exist.
   */
  id?: Maybe<Scalars['UUID']>;
  /**
   * This flag means that this entry was previously selected by the customer, but it is not available anymore at STIHL
   * since it is not provided by the external API.
   *
   * The customer can select and obsolete entry as favorite.
   */
  isObsolete: Scalars['Boolean'];
  /** The product favorite status as described in the ProductFavoriteStatus enum. */
  status: ProductFavoriteStatus;
};

/** The input for selectableBarAndChainFavorites query. */
export type SelectableBarAndChainFavoritesInput = {
  /** Product ID to get the existing favorite bar and chain combinations. */
  productId: Scalars['String'];
};

/** The response for the selectableBarAndChainFavorites query */
export type SelectableBarAndChainFavoritesResponse = {
  __typename?: 'SelectableBarAndChainFavoritesResponse';
  /**
   * The list of selectable bar and chain combination favorites, including
   * available bar and chain combinations, favorite and obsolete entries.
   */
  items: Array<SelectableBarAndChainFavorite>;
};

/** The ServiceKit STIHL product accessory */
export type ServiceKit = {
  __typename?: 'ServiceKit';
  /** The accessories URL for the batteries */
  accessoryUrl?: Maybe<Scalars['String']>;
  /** The individual parts of the ServiceKit */
  components?: Maybe<Array<ServiceKitComponent>>;
  /** The imageUrl of the battery */
  imageUrl: Scalars['String'];
  /** indicates if the image behind imageUrl is a fallback image */
  isFallbackImage: Scalars['Boolean'];
  /** The material number of the ServiceKit */
  materialNumber: Scalars['String'];
  /** An optional note for the ServiceKit */
  note?: Maybe<Scalars['String']>;
  /** The ServiceKit name */
  text: Scalars['String'];
};

/** The ServiceKit component */
export type ServiceKitComponent = {
  __typename?: 'ServiceKitComponent';
  /** The material number of a ServiceKit component */
  materialNumber: Scalars['String'];
  /** The description of a ServiceKit component */
  text: Scalars['String'];
};

/** The product favorite type for a ServiceKit */
export type ServiceKitFavorite = {
  __typename?: 'ServiceKitFavorite';
  /** The ServiceKit data. */
  accessory: ServiceKit;
  /** The ServiceKit favorite ID. */
  id?: Maybe<Scalars['UUID']>;
  /** The product favorite status as described in the ProductFavoriteStatus enum. */
  status: ProductFavoriteStatus;
};

/** The input for CreateServiceKitFavoriteInput. */
export type ServiceKitFavoriteInput = {
  /** Optional: Use this parameter to override the default behaviour of using the users profile language for translations. */
  overrideLocale?: InputMaybe<Scalars['String']>;
  /** The ServiceKit material number to be added as favorite. */
  serviceKitMaterialNumber: Scalars['String'];
};

/** The input for ServiceKitFavorites subquery of productFavorites */
export type ServiceKitFavoritesInput = {
  /** An option to filter by product favorite statuses. If not provided will return ACTIVE and DEPRECATED favorites. */
  statuses?: InputMaybe<Array<ProductFavoriteStatus>>;
};

/** The response for ServiceKitFavoritesResponse sub query of productFavorites. */
export type ServiceKitFavoritesResponse = {
  __typename?: 'ServiceKitFavoritesResponse';
  /** The list of ServiceKit favorites. */
  items: Array<ServiceKitFavorite>;
};

export type ServiceKitResponse = {
  __typename?: 'ServiceKitResponse';
  /** The list of available service kits, including the available service kits, favorite and obsolete entries. */
  items: Array<ServiceKitFavorite>;
};

/** The service protocol details */
export type ServiceProtocol = {
  __typename?: 'ServiceProtocol';
  /** Care product object containing the descriptions for the services to the customer. */
  careProduct: CareProduct;
};

/** The product's service reminder data, including the next service date and reminder date. */
export type ServiceReminder = {
  __typename?: 'ServiceReminder';
  /** The interval to remind the customer about a service, for example same day, week month or week before or custom date. */
  interval: ServiceReminderInterval;
  /** Next service date of a product. */
  nextServiceDate?: Maybe<Scalars['String']>;
  /** Flag to indicate if the user wants to be reminded by email. */
  remindByEmail: Scalars['Boolean'];
  /** Reminder of a product service, in case of opting for a custom date. */
  reminderDate?: Maybe<Scalars['String']>;
};

/**
 * The different options for the service reminder interval, for example
 * same day, week month or week before or custom date.
 */
export enum ServiceReminderInterval {
  /** Custom service reminder date. The date of the reminder will be the one informed by the user. */
  CustomDate = 'CUSTOM_DATE',
  /** Do not remind the user. */
  NotRemindMe = 'NOT_REMIND_ME',
  /** Service reminder date of one month before the service date. */
  OneMonthBefore = 'ONE_MONTH_BEFORE',
  /** Service reminder date of one week before the service date. */
  OneWeekBefore = 'ONE_WEEK_BEFORE',
  /** Service reminder date of the same day of the service date. */
  SameDay = 'SAME_DAY'
}

/** The service reminder data for the registration process. */
export type ServiceReminderToRegisterInput = {
  /** The interval to remind the customer about a service, for example same day, week month or week before or custom date. */
  interval: ServiceReminderInterval;
  /** Next service date of a product. */
  nextServiceDate?: InputMaybe<Scalars['String']>;
  /** Flag to indicate if the user wants to be reminded by email. */
  remindByEmail: Scalars['Boolean'];
  /** Reminder of a product service, in case of opting for a custom date. */
  reminderDate?: InputMaybe<Scalars['String']>;
};

/** The service reminder data for the update process. */
export type ServiceReminderToUpdateInput = {
  /** The interval to remind the customer about a service, for example same day, week month or week before or custom date. */
  interval?: InputMaybe<ServiceReminderInterval>;
  /** Next service date of a product. */
  nextServiceDate?: InputMaybe<Scalars['String']>;
  /** Flag to indicate if the user wants to be reminded by email. */
  remindByEmail?: InputMaybe<Scalars['Boolean']>;
  /** Reminder of a product service, in case of opting for a custom date. */
  reminderDate?: InputMaybe<Scalars['String']>;
};

/** Input parameters of resetDefaultProfileImageToFallback Mutation */
export type SetDefaultFallbackProfileImageInput = {
  /**
   * Product ID that will have its product attachments of type profile image set as false, so that the PCIS or fallback will
   * be considered as
   */
  productId: Scalars['UUID'];
};

/** Response for resetDefaultProfileImageToFallback Mutation. */
export type SetDefaultFallbackProfileImageResponse = {
  __typename?: 'SetDefaultFallbackProfileImageResponse';
  previousDefaultProductAttachment?: Maybe<ProductAttachment>;
};

/** Type that represents a spare part */
export type SparePart = {
  __typename?: 'SparePart';
  /** The accessories URL for the spare part */
  accessoryUrl?: Maybe<Scalars['String']>;
  /** The category of the spare part */
  category: Scalars['String'];
  /** The imageUrl of the spare part */
  imageUrl: Scalars['String'];
  /** indicates if the image behind imageUrl is a fallback image */
  isFallbackImage: Scalars['Boolean'];
  /** The spare part ID */
  sparePartId: Scalars['String'];
  /** The spare part name translated to the users locale */
  sparePartNameTranslation?: Maybe<Scalars['String']>;
};

/** The product favorite type for a spare part. */
export type SparePartFavorite = {
  __typename?: 'SparePartFavorite';
  /** The spare part data. */
  accessory: SparePart;
  /** The product accessory favorite ID. */
  id?: Maybe<Scalars['UUID']>;
  /**
   * This flag means that this entry was previously selected by the customer, but it is not available anymore at STIHL
   * since it is not provided by the external API.
   *
   * The customer can select and obsolete entry as favorite.
   */
  isObsolete: Scalars['Boolean'];
  /** The product favorite status as described in the ProductFavoriteStatus enum. */
  status: ProductFavoriteStatus;
};

/** The input for SparePartFavoriteInput. */
export type SparePartFavoriteInput = {
  /** The id of the spare part. */
  sparePartId: Scalars['String'];
};

/** The response for the sub query productAccessories#spareParts */
export type SparePartResponse = {
  __typename?: 'SparePartResponse';
  /**
   * The list of available spare parts, including the available
   * spareParts, favorite and obsolete entries.
   */
  items: Array<SparePartFavorite>;
};

/** The `TimberSportsEvent` type represents a single TimberSports event. */
export type TimberSportsEvent = {
  __typename?: 'TimberSportsEvent';
  /** The start date of the event. */
  begin: Scalars['DateString'];
  /** The name of the event's category. */
  category: Scalars['String'];
  /** The end date of the event. */
  end: Scalars['DateString'];
  /** The unique ID of the event. */
  id: Scalars['String'];
  /** The URL of the event's teaser image. */
  imageUrl: Scalars['String'];
  /** The URL of the event's live stream. */
  liveUrl?: Maybe<Scalars['String']>;
  /** The name of the event's location. */
  location: Scalars['String'];
  /** The name of the event. */
  name: Scalars['String'];
  /** The name of the event's nation. */
  nation: Scalars['String'];
  /** The 3-letter code of the event's nation. */
  nationAlpha3: Scalars['String'];
  /** The URL of the event's ticket ordering website. */
  ticketUrl?: Maybe<Scalars['String']>;
};

/** The `TimberSportEvents` type represents a list of TimberSports events. */
export type TimberSportsEvents = {
  __typename?: 'TimberSportsEvents';
  /** The list of TimberSport events. Can be empty. */
  items: Array<Maybe<TimberSportsEvent>>;
};

/** The `TimberSportsInput` type represents the input parameters of the `events` query. */
export type TimberSportsInput = {
  /**
   * The country of the events to return. Defaults to `DEU`.
   *
   * Can be an alpha-2 or alpha-3 country code. (e.g. `DE` or `DEU`, `US` or `USA`, `GB` or `GBR` etc.)
   */
  country?: InputMaybe<Scalars['String']>;
  /** The number of events to return. Defaults to 10. */
  limit?: InputMaybe<Scalars['Int']>;
};

/** Touchpoint which owns the setting */
export type TouchPoint = {
  __typename?: 'TouchPoint';
  /** The identifier for the touchpoint */
  name: Scalars['String'];
};

export type TouchPointCreateInput = {
  /** The name of the touchpoint */
  name: Scalars['String'];
};

/**
 * Represents the data related to a STIHL product which is not registered within MySTIHL.
 * The product information is provided by multiple sources and aggregated by PCIS.
 */
export type UnregisteredProduct = {
  __typename?: 'UnregisteredProduct';
  /** The article number as defined in the ERP system. */
  articleNumber?: Maybe<Scalars['String']>;
  /** The product image provided by PCIS. */
  imageSrc?: Maybe<Scalars['String']>;
  /**
   * Indicates that the imageSrc URL is in fact a fallback image of the product category. This means that if
   * the flag is true, the image comes from the product category and image mapping, maintained in Contentful.
   */
  isFallbackImage?: Maybe<Scalars['Boolean']>;
  /** The product category provided by PCIS. */
  productCategory?: Maybe<ProductCategory>;
  /** The product drive type provided by PCIS. */
  productDriveType?: Maybe<ProductDriveType>;
  /** Product name within PCIS */
  productName?: Maybe<Scalars['String']>;
  /** The purchase date of a product. */
  purchaseDate?: Maybe<Scalars['String']>;
  /** List of dynamic questions that must be answered to register this product. */
  questions?: Maybe<ProductRegistrationQuestions>;
  /** Product registration date within SNDB. */
  registrationDate?: Maybe<Scalars['String']>;
  /** Product serial number */
  serialNumber: Scalars['SerialNumber'];
  /** ServiceReminder of a product */
  serviceReminder?: Maybe<ServiceReminder>;
  /** The warranty end date of a product. */
  warrantyEndDate?: Maybe<Scalars['String']>;
};

/** The input data for the  query. */
export type UnregisteredProductInput = {
  /** The serial number of the product. */
  serialNumber: Scalars['SerialNumber'];
};

/** Response for the unregisteredProductsFromCRM query. */
export type UnregisteredProductsFromCrmResponse = {
  __typename?: 'UnregisteredProductsFromCRMResponse';
  /** List of products which are not registered in MySTIHL */
  items: Array<UnregisteredProduct>;
};

/**
 * Input parameters to update the product attachment metadata such
 * as defaultProfileImage
 */
export type UpdateProductAttachmentInput = {
  /** Is the default profile image */
  defaultProfileImage: Scalars['Boolean'];
  /** Product Attachment identifier */
  productAttachmentId: Scalars['UUID'];
  /** Product ID from which the product attachment belongs to */
  productId: Scalars['UUID'];
  /** STIHL ID of the user updating the attachment */
  stihlId: Scalars['String'];
};

/** Response for update product attachment mutation. */
export type UpdateProductAttachmentResponse = {
  __typename?: 'UpdateProductAttachmentResponse';
  /** Product attachment updated */
  productAttachment?: Maybe<ProductAttachment>;
};

/** The input data for the updateProduct mutation. */
export type UpdateProductInput = {
  /** The product data to be updated. */
  product: ProductToUpdateInput;
  /** The STIHL ID of the product. */
  stihlId: Scalars['UUID'];
};

/** Response for productUpdate mutation. */
export type UpdateProductResponse = {
  __typename?: 'UpdateProductResponse';
  /** The product data updated. */
  product: Product;
  /** The STIHL ID of the product. */
  stihlId: Scalars['UUID'];
};

/** Upload product attachment input parameters. */
export type UploadProductAttachmentsInput = {
  /** List of files to upload */
  files: Array<Scalars['Upload']>;
  /** Product ID from which the product attachment belongs to */
  productId: Scalars['UUID'];
  /** STIHL ID of the user uploading the attachment */
  stihlId: Scalars['String'];
  /** Attachment file type */
  type: AttachmentType;
};

/** Response for product attachment */
export type UploadProductAttachmentsResponse = {
  __typename?: 'UploadProductAttachmentsResponse';
  /**
   * Since it is a bulk upload of attachments, there is a requirement to not block the upload in case
   * one or more attachments upload fails. This prevents us to use the general GraphQL error format (errors property)
   * for the upload failures.
   * # Note that any global exceptions will still be show in the GraphQL normal errors property.
   */
  failedUploads: Array<FailedUploadProductAttachment>;
  /** List of product attachments representing the files uploaded */
  items: Array<ProductAttachment>;
};

/** The user type. */
export type User = {
  __typename?: 'User';
  /**
   * Query to return one product of the user, searching by product id.
   *
   * * It is only possible to retrieve a product that belongs to the logged user. This means that the STIHL ID
   * in the request should match the STIHL ID of the logged user, according to the token.
   */
  product?: Maybe<Product>;
  /**
   * Query to list and filter the products of the user.
   *
   * * It is only possible to retrieve the list of products of the logged user. This means that the STIHL ID
   * in the request should match the STIHL ID of the logged user, according to the token.
   */
  products?: Maybe<ProductsResponse>;
  /** The STIHL Id of the user. */
  stihlId: Scalars['UUID'];
};


/** The user type. */
export type UserProductArgs = {
  input?: InputMaybe<ProductInput>;
};


/** The user type. */
export type UserProductsArgs = {
  input?: InputMaybe<ProductsInput>;
};

/** Input for the user query. */
export type UserInput = {
  /** The STIHL Id of the user. */
  stihlId: Scalars['UUID'];
};

export type UserSetting = {
  __typename?: 'UserSetting';
  /**
   * This is the unique identifier for the setting.
   * We recommend to use the following naming convention: <business-domain>.<setting-name>
   */
  name: Scalars['String'];
  /** Touchpoint who owns the setting */
  ownedBy: TouchPoint;
  /** Generic setting serialized as JSON. You can use any structure which fits your needs. */
  setting: Scalars['JSON'];
  /** The last touchpoint who updated the settings */
  updatedBy?: Maybe<TouchPoint>;
};

/** Input for creating a new setting */
export type UserSettingCreateInput = {
  /**
   * This is the unique identifier for the setting.
   * We recommend to use the following naming convention: <business-domain>.<setting-name>
   */
  name: Scalars['String'];
  /** Touchpoint who owns the setting */
  ownedBy: TouchPointCreateInput;
  /** Represents the permission for the setting. Those settings are only valid for touchpoints who are not owning the setting. */
  permission?: InputMaybe<PermissionCreateInput>;
  /** Generic setting serialized as JSON. You can use any structure which fits your needs. */
  setting: Scalars['JSON'];
};

export type UserSettingDeleteInput = {
  /** The setting name you want to delete */
  name: Scalars['String'];
  /** The touchpoint who update the setting */
  updatedBy: TouchPointCreateInput;
};

export type UserSettingUpdateInput = {
  /**
   * This is the unique identifier for the setting.
   * We recommend to use the following naming convention: <business-domain>.<setting-name>
   */
  name: Scalars['String'];
  /** Generic setting serialized as JSON. You can use any structure which fits your needs. */
  setting: Scalars['JSON'];
  /** Use the touchpoint who update the setting */
  updatedBy: TouchPointCreateInput;
};

/** Response for the Videos query */
export type VideosResponse = {
  __typename?: 'VideosResponse';
  /** Wrappper object containing different types of available video sources */
  youtube?: Maybe<YoutubeVideos>;
};

/** Type describing the different kinds of possible youtube thumbnails */
export type YoutubeThumbnail = {
  __typename?: 'YoutubeThumbnail';
  /** default thumbnail size */
  default?: Maybe<YoutubeThumbnailResolution>;
  /** big thumbnail size */
  high?: Maybe<YoutubeThumbnailResolution>;
  /** maximal thumbnail size */
  maxres?: Maybe<YoutubeThumbnailResolution>;
  /** medium thumbnail size */
  medium?: Maybe<YoutubeThumbnailResolution>;
  /** standard thumbnail size */
  standard?: Maybe<YoutubeThumbnailResolution>;
};

/** Type representing a youtube thumbnail resolution */
export type YoutubeThumbnailResolution = {
  __typename?: 'YoutubeThumbnailResolution';
  /** height of the thumbnail */
  height?: Maybe<Scalars['Int']>;
  /** url to the thumbnail */
  url?: Maybe<Scalars['String']>;
  /** width of the thumbnail */
  width?: Maybe<Scalars['Int']>;
};

/** Type representing a youtube video */
export type YoutubeVideo = {
  __typename?: 'YoutubeVideo';
  /** Description of the youtube video */
  description?: Maybe<Scalars['String']>;
  /** publishing DateTime */
  publishedAt?: Maybe<Scalars['String']>;
  /** thumbnail of the youtube video */
  thumbnail?: Maybe<YoutubeThumbnail>;
  /** Title of the youtube video */
  title?: Maybe<Scalars['String']>;
  /** url to the youtube video */
  url?: Maybe<Scalars['String']>;
};

/** Input for retrieving Youtube videos */
export type YoutubeVideoInput = {
  /** The amount of videos to fetch */
  limit?: InputMaybe<Scalars['Int']>;
  /** The locale for which to fetch the videos */
  locale?: InputMaybe<Scalars['String']>;
};

/** Type describing a Youtube video Section like for example a playlist or latest videos from a channel */
export type YoutubeVideoSection = {
  __typename?: 'YoutubeVideoSection';
  /** Defines whether the returned section is from a fallback or not. */
  isFallback?: Maybe<Scalars['Boolean']>;
  /**
   * the url of the resource
   * in case of
   * latest -> url to the youtube channel
   * playlist -> url to the playlist
   */
  url?: Maybe<Scalars['String']>;
  videos: Array<YoutubeVideo>;
};

/** Type containing the different kinds of youtube videos */
export type YoutubeVideos = {
  __typename?: 'YoutubeVideos';
  /**
   * videos from the doItYourself playlist
   * which playlist is used is dependent on the users locale
   */
  doItYourself?: Maybe<YoutubeVideoSection>;
  /**
   * videos from the forProfessionals playlist
   * which playlist is used is dependent on the users locale
   */
  forProfessionals?: Maybe<YoutubeVideoSection>;
  /**
   * videos from the gardening playlist
   * which playlist is used is dependent on the users locale
   */
  gardening?: Maybe<YoutubeVideoSection>;
  /**
   * latest videos for a given youtube channel
   * which channel is used is dependent on the users locale
   */
  latest?: Maybe<YoutubeVideoSection>;
};


/** Type containing the different kinds of youtube videos */
export type YoutubeVideosDoItYourselfArgs = {
  input?: InputMaybe<YoutubeVideoInput>;
};


/** Type containing the different kinds of youtube videos */
export type YoutubeVideosForProfessionalsArgs = {
  input?: InputMaybe<YoutubeVideoInput>;
};


/** Type containing the different kinds of youtube videos */
export type YoutubeVideosGardeningArgs = {
  input?: InputMaybe<YoutubeVideoInput>;
};


/** Type containing the different kinds of youtube videos */
export type YoutubeVideosLatestArgs = {
  input?: InputMaybe<YoutubeVideoInput>;
};

export type GetEditorialContentQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  stihlId: Scalars['UUID'];
  productTypes: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetEditorialContentQuery = { __typename?: 'Query', productEditorialContent?: { __typename?: 'ProductEditorialContentResponse', items: Array<{ __typename?: 'ProductEditorialContent', description: string, title: string, contentUrl: string, imageUrl: string, rawImageUrl: string, imageAltText: string } | null> } | null };

export type GetInteractiveGardenArticlesQueryVariables = Exact<{
  filters?: InputMaybe<Array<InteractiveGardenFilter> | InteractiveGardenFilter>;
}>;


export type GetInteractiveGardenArticlesQuery = { __typename?: 'Query', interactiveGardenArticles?: { __typename?: 'InteractiveGardenArticleResponse', items: Array<{ __typename?: 'ProductEditorialContent', title: string, description: string, imageUrl: string, contentUrl: string, rawImageUrl: string, imageAltText: string } | null> } | null };

export type GetEventsQueryVariables = Exact<{
  country?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetEventsQuery = { __typename?: 'Query', events?: { __typename?: 'EventsResponse', timberSports: { __typename?: 'TimberSportsEvents', items: Array<{ __typename?: 'TimberSportsEvent', id: string, name: string, location: string, begin: any, imageUrl: string, liveUrl?: string | null, ticketUrl?: string | null } | null> } } | null };

export type GetNewsQueryVariables = Exact<{
  locale: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetNewsQuery = { __typename?: 'Query', news?: { __typename?: 'NewsResponse', items: Array<{ __typename?: 'News', id: string, headline: string, contentUrl?: string | null, previewText: string, imageUrl?: string | null, targetSystem: Array<string | null> }> } | null };

export type GetCustomerRecommendationsQueryVariables = Exact<{
  input: CustomerRecommendationsInput;
}>;


export type GetCustomerRecommendationsQuery = { __typename?: 'Query', productRecommendations?: { __typename?: 'ProductRecommendationsResponse', nextBestOffers?: { __typename?: 'NextBestOffers', customerRecommendations: Array<{ __typename?: 'NextBestOffer', productName: string, articleNumber: string, callToActionUrl?: string | null, imageUrl?: string | null, category?: { __typename?: 'ProductCategory', name: string, categoryGroup?: { __typename?: 'ProductCategoryGroup', name: string } | null } | null, driveType?: { __typename?: 'ProductDriveType', name: string } | null } | null> } | null } | null };

export type GetBatteryCompatibleProductsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetBatteryCompatibleProductsQuery = { __typename?: 'Query', productRecommendations?: { __typename?: 'ProductRecommendationsResponse', compatibleProducts?: { __typename?: 'CompatibleProducts', batteryCompatibleProducts: Array<{ __typename?: 'BatteryCompatibleProduct', productName: string, articleNumber: string, maxRuntime?: number | null, imageUrl: string, callToActionUrl?: string | null, category?: { __typename?: 'ProductCategory', name: string, categoryGroup?: { __typename?: 'ProductCategoryGroup', name: string } | null } | null, driveType?: { __typename?: 'ProductDriveType', name: string } | null, compatibleBatteries: Array<{ __typename?: 'CompatibleBattery', productName: string }> }> } | null } | null };

export type GetProductCompatibleBatteriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductCompatibleBatteriesQuery = { __typename?: 'Query', productRecommendations?: { __typename?: 'ProductRecommendationsResponse', compatibleProducts?: { __typename?: 'CompatibleProducts', productCompatibleBatteries: Array<{ __typename?: 'ProductCompatibleBattery', productName: string, articleNumber: string, imageUrl?: string | null, isFallbackImage?: boolean | null, callToActionUrl?: string | null, category?: { __typename?: 'ProductCategory', name: string, categoryGroup?: { __typename?: 'ProductCategoryGroup', name: string } | null } | null, compatibleBatteries: Array<{ __typename?: 'CompatibleProductBattery', isOwned: boolean, productName: string, materialNumber: string, callToActionUrl?: string | null, maxRuntime: number, imageUrl?: string | null, category?: { __typename?: 'ProductCategory', name: string } | null, runtimeStats?: { __typename?: 'BatteryRuntimeStats', baseRuntime?: number | null, runtimeBoost?: number | null, runtimeBoostPercentage?: number | null } | null }> }> } | null } | null };

export type NextBestOfferFieldsFragment = { __typename?: 'NextBestOffer', productName: string, articleNumber: string, callToActionUrl?: string | null, imageUrl?: string | null, category?: { __typename?: 'ProductCategory', name: string, categoryGroup?: { __typename?: 'ProductCategoryGroup', name: string } | null } | null, driveType?: { __typename?: 'ProductDriveType', name: string } | null };

export type BatteryCompatibleProductFieldsFragment = { __typename?: 'BatteryCompatibleProduct', productName: string, articleNumber: string, maxRuntime?: number | null, imageUrl: string, callToActionUrl?: string | null, category?: { __typename?: 'ProductCategory', name: string, categoryGroup?: { __typename?: 'ProductCategoryGroup', name: string } | null } | null, driveType?: { __typename?: 'ProductDriveType', name: string } | null, compatibleBatteries: Array<{ __typename?: 'CompatibleBattery', productName: string }> };

export type ProductCompatibleBatteriesFieldsFragment = { __typename?: 'ProductCompatibleBattery', productName: string, articleNumber: string, imageUrl?: string | null, isFallbackImage?: boolean | null, callToActionUrl?: string | null, category?: { __typename?: 'ProductCategory', name: string, categoryGroup?: { __typename?: 'ProductCategoryGroup', name: string } | null } | null, compatibleBatteries: Array<{ __typename?: 'CompatibleProductBattery', isOwned: boolean, productName: string, materialNumber: string, callToActionUrl?: string | null, maxRuntime: number, imageUrl?: string | null, category?: { __typename?: 'ProductCategory', name: string } | null, runtimeStats?: { __typename?: 'BatteryRuntimeStats', baseRuntime?: number | null, runtimeBoost?: number | null, runtimeBoostPercentage?: number | null } | null }> };

export type GetUserProductsQueryVariables = Exact<{
  stihlId: Scalars['UUID'];
  limit?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
  withServiceReminder?: InputMaybe<Scalars['Boolean']>;
  withManual?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetUserProductsQuery = { __typename?: 'Query', user?: { __typename?: 'User', products?: { __typename?: 'ProductsResponse', items: Array<{ __typename?: 'Product', id: any, serialNumber?: any | null, productName?: string | null, customName: string, imageSrc?: string | null, isFallbackImage?: boolean | null, serviceReminder?: { __typename?: 'ServiceReminder', reminderDate?: string | null, nextServiceDate?: string | null } | null, productManualFile?: { __typename?: 'MaintenanceDocumentFile', url: string, type: string } | null, productCategory?: { __typename?: 'ProductCategory', name: string, categoryGroup?: { __typename?: 'ProductCategoryGroup', name: string } | null } | null, productDriveType?: { __typename?: 'ProductDriveType', name: string } | null }> } | null } | null };

export type BaseProductFieldsFragment = { __typename?: 'Product', id: any, serialNumber?: any | null, productName?: string | null, customName: string, imageSrc?: string | null, isFallbackImage?: boolean | null, productCategory?: { __typename?: 'ProductCategory', name: string, categoryGroup?: { __typename?: 'ProductCategoryGroup', name: string } | null } | null, productDriveType?: { __typename?: 'ProductDriveType', name: string } | null };

export type GetUserSettingsQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetUserSettingsQuery = { __typename?: 'Query', userSetting?: { __typename?: 'UserSetting', name: string, setting: Record<string, unknown> } | null };

export type CreateUserSettingsMutationVariables = Exact<{
  setting: Scalars['JSON'];
  name: Scalars['String'];
}>;


export type CreateUserSettingsMutation = { __typename?: 'Mutation', createUserSetting?: { __typename?: 'UserSetting', name: string, setting: Record<string, unknown> } | null };

export type UpdateUserSettingsMutationVariables = Exact<{
  setting: Scalars['JSON'];
  name: Scalars['String'];
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', updateUserSetting?: { __typename?: 'UserSetting', name: string, setting: Record<string, unknown> } | null };

export type UserSettingFieldsFragment = { __typename?: 'UserSetting', name: string, setting: Record<string, unknown> };

export type GetVideosQueryVariables = Exact<{
  locale: Scalars['String'];
}>;


export type GetVideosQuery = { __typename?: 'Query', videos?: { __typename?: 'VideosResponse', youtube?: { __typename?: 'YoutubeVideos', latest?: { __typename?: 'YoutubeVideoSection', url?: string | null, isFallback?: boolean | null, videos: Array<{ __typename?: 'YoutubeVideo', title?: string | null, url?: string | null, publishedAt?: string | null, thumbnail?: { __typename?: 'YoutubeThumbnail', standard?: { __typename?: 'YoutubeThumbnailResolution', url?: string | null } | null, high?: { __typename?: 'YoutubeThumbnailResolution', url?: string | null } | null, maxres?: { __typename?: 'YoutubeThumbnailResolution', url?: string | null } | null } | null }> } | null, doItYourself?: { __typename?: 'YoutubeVideoSection', url?: string | null, isFallback?: boolean | null, videos: Array<{ __typename?: 'YoutubeVideo', title?: string | null, url?: string | null, publishedAt?: string | null, thumbnail?: { __typename?: 'YoutubeThumbnail', standard?: { __typename?: 'YoutubeThumbnailResolution', url?: string | null } | null, high?: { __typename?: 'YoutubeThumbnailResolution', url?: string | null } | null, maxres?: { __typename?: 'YoutubeThumbnailResolution', url?: string | null } | null } | null }> } | null, gardening?: { __typename?: 'YoutubeVideoSection', url?: string | null, isFallback?: boolean | null, videos: Array<{ __typename?: 'YoutubeVideo', title?: string | null, url?: string | null, publishedAt?: string | null, thumbnail?: { __typename?: 'YoutubeThumbnail', standard?: { __typename?: 'YoutubeThumbnailResolution', url?: string | null } | null, high?: { __typename?: 'YoutubeThumbnailResolution', url?: string | null } | null, maxres?: { __typename?: 'YoutubeThumbnailResolution', url?: string | null } | null } | null }> } | null, forProfessionals?: { __typename?: 'YoutubeVideoSection', url?: string | null, isFallback?: boolean | null, videos: Array<{ __typename?: 'YoutubeVideo', title?: string | null, url?: string | null, publishedAt?: string | null, thumbnail?: { __typename?: 'YoutubeThumbnail', standard?: { __typename?: 'YoutubeThumbnailResolution', url?: string | null } | null, high?: { __typename?: 'YoutubeThumbnailResolution', url?: string | null } | null, maxres?: { __typename?: 'YoutubeThumbnailResolution', url?: string | null } | null } | null }> } | null } | null } | null };

export type YoutubeVideoSectionFieldsFragment = { __typename?: 'YoutubeVideoSection', url?: string | null, isFallback?: boolean | null, videos: Array<{ __typename?: 'YoutubeVideo', title?: string | null, url?: string | null, publishedAt?: string | null, thumbnail?: { __typename?: 'YoutubeThumbnail', standard?: { __typename?: 'YoutubeThumbnailResolution', url?: string | null } | null, high?: { __typename?: 'YoutubeThumbnailResolution', url?: string | null } | null, maxres?: { __typename?: 'YoutubeThumbnailResolution', url?: string | null } | null } | null }> };

export const NextBestOfferFieldsFragmentDoc = gql`
    fragment NextBestOfferFields on NextBestOffer {
  productName
  articleNumber
  category {
    name
    categoryGroup {
      name
    }
  }
  driveType {
    name
  }
  callToActionUrl
  imageUrl
}
    `;
export const BatteryCompatibleProductFieldsFragmentDoc = gql`
    fragment BatteryCompatibleProductFields on BatteryCompatibleProduct {
  productName
  articleNumber
  category {
    name
    categoryGroup {
      name
    }
  }
  driveType {
    name
  }
  maxRuntime
  imageUrl
  callToActionUrl
  compatibleBatteries {
    productName
  }
}
    `;
export const ProductCompatibleBatteriesFieldsFragmentDoc = gql`
    fragment ProductCompatibleBatteriesFields on ProductCompatibleBattery {
  productName
  articleNumber
  imageUrl
  isFallbackImage
  callToActionUrl
  category {
    name
    categoryGroup {
      name
    }
  }
  compatibleBatteries {
    isOwned
    productName
    materialNumber
    callToActionUrl
    maxRuntime
    imageUrl
    category {
      name
    }
    runtimeStats {
      baseRuntime
      runtimeBoost
      runtimeBoostPercentage
    }
  }
}
    `;
export const BaseProductFieldsFragmentDoc = gql`
    fragment BaseProductFields on Product {
  id
  serialNumber
  productName
  customName
  imageSrc
  isFallbackImage
  productCategory {
    name
    categoryGroup {
      name
    }
  }
  productDriveType {
    name
  }
}
    `;
export const UserSettingFieldsFragmentDoc = gql`
    fragment UserSettingFields on UserSetting {
  name
  setting
}
    `;
export const YoutubeVideoSectionFieldsFragmentDoc = gql`
    fragment YoutubeVideoSectionFields on YoutubeVideoSection {
  url
  isFallback
  videos {
    title
    url
    publishedAt
    thumbnail {
      standard {
        url
      }
      high {
        url
      }
      maxres {
        url
      }
    }
  }
}
    `;
export const GetEditorialContentDocument = gql`
    query getEditorialContent($limit: Int, $stihlId: UUID!, $productTypes: [String!]!) {
  productEditorialContent(
    input: {limit: $limit, stihlId: $stihlId, productTypes: $productTypes}
  ) {
    items {
      description
      title
      contentUrl
      imageUrl
      rawImageUrl
      imageAltText
    }
  }
}
    `;

export function useGetEditorialContentQuery(options: Omit<Urql.UseQueryArgs<GetEditorialContentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEditorialContentQuery, GetEditorialContentQueryVariables>({ query: GetEditorialContentDocument, ...options });
};
export const GetInteractiveGardenArticlesDocument = gql`
    query getInteractiveGardenArticles($filters: [InteractiveGardenFilter!]) {
  interactiveGardenArticles(input: {filterTags: $filters, offset: 0, limit: 100}) {
    items {
      title
      description
      imageUrl
      contentUrl
      rawImageUrl
      imageAltText
    }
  }
}
    `;

export function useGetInteractiveGardenArticlesQuery(options?: Omit<Urql.UseQueryArgs<GetInteractiveGardenArticlesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetInteractiveGardenArticlesQuery, GetInteractiveGardenArticlesQueryVariables>({ query: GetInteractiveGardenArticlesDocument, ...options });
};
export const GetEventsDocument = gql`
    query getEvents($country: String, $limit: Int) {
  events {
    timberSports(input: {country: $country, limit: $limit}) {
      items {
        id
        name
        location
        begin
        imageUrl
        liveUrl
        ticketUrl
      }
    }
  }
}
    `;

export function useGetEventsQuery(options?: Omit<Urql.UseQueryArgs<GetEventsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEventsQuery, GetEventsQueryVariables>({ query: GetEventsDocument, ...options });
};
export const GetNewsDocument = gql`
    query getNews($locale: String!, $limit: Int) {
  news(input: {locale: $locale, limit: $limit}) {
    items {
      id
      headline
      contentUrl
      previewText
      imageUrl
      targetSystem
    }
  }
}
    `;

export function useGetNewsQuery(options: Omit<Urql.UseQueryArgs<GetNewsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNewsQuery, GetNewsQueryVariables>({ query: GetNewsDocument, ...options });
};
export const GetCustomerRecommendationsDocument = gql`
    query getCustomerRecommendations($input: CustomerRecommendationsInput!) {
  productRecommendations {
    nextBestOffers {
      customerRecommendations(input: $input) {
        ...NextBestOfferFields
      }
    }
  }
}
    ${NextBestOfferFieldsFragmentDoc}`;

export function useGetCustomerRecommendationsQuery(options: Omit<Urql.UseQueryArgs<GetCustomerRecommendationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCustomerRecommendationsQuery, GetCustomerRecommendationsQueryVariables>({ query: GetCustomerRecommendationsDocument, ...options });
};
export const GetBatteryCompatibleProductsDocument = gql`
    query getBatteryCompatibleProducts($limit: Int) {
  productRecommendations {
    compatibleProducts {
      batteryCompatibleProducts(input: {limit: $limit}) {
        ...BatteryCompatibleProductFields
      }
    }
  }
}
    ${BatteryCompatibleProductFieldsFragmentDoc}`;

export function useGetBatteryCompatibleProductsQuery(options?: Omit<Urql.UseQueryArgs<GetBatteryCompatibleProductsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBatteryCompatibleProductsQuery, GetBatteryCompatibleProductsQueryVariables>({ query: GetBatteryCompatibleProductsDocument, ...options });
};
export const GetProductCompatibleBatteriesDocument = gql`
    query getProductCompatibleBatteries {
  productRecommendations {
    compatibleProducts {
      productCompatibleBatteries {
        ...ProductCompatibleBatteriesFields
      }
    }
  }
}
    ${ProductCompatibleBatteriesFieldsFragmentDoc}`;

export function useGetProductCompatibleBatteriesQuery(options?: Omit<Urql.UseQueryArgs<GetProductCompatibleBatteriesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProductCompatibleBatteriesQuery, GetProductCompatibleBatteriesQueryVariables>({ query: GetProductCompatibleBatteriesDocument, ...options });
};
export const GetUserProductsDocument = gql`
    query getUserProducts($stihlId: UUID!, $limit: Int, $cursor: String, $withServiceReminder: Boolean = false, $withManual: Boolean = false) {
  user(input: {stihlId: $stihlId}) {
    products(input: {limit: $limit, cursor: $cursor}) {
      items {
        ...BaseProductFields
        serviceReminder @include(if: $withServiceReminder) {
          reminderDate
          nextServiceDate
        }
        productManualFile @include(if: $withManual) {
          url
          type
        }
      }
    }
  }
}
    ${BaseProductFieldsFragmentDoc}`;

export function useGetUserProductsQuery(options: Omit<Urql.UseQueryArgs<GetUserProductsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserProductsQuery, GetUserProductsQueryVariables>({ query: GetUserProductsDocument, ...options });
};
export const GetUserSettingsDocument = gql`
    query getUserSettings($name: String!) {
  userSetting(name: $name) {
    ...UserSettingFields
  }
}
    ${UserSettingFieldsFragmentDoc}`;

export function useGetUserSettingsQuery(options: Omit<Urql.UseQueryArgs<GetUserSettingsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserSettingsQuery, GetUserSettingsQueryVariables>({ query: GetUserSettingsDocument, ...options });
};
export const CreateUserSettingsDocument = gql`
    mutation createUserSettings($setting: JSON!, $name: String!) {
  createUserSetting(
    userSettingCreateData: {setting: $setting, name: $name, ownedBy: {name: "dashboard"}, permission: {read: true, write: false, delete: false}}
  ) {
    ...UserSettingFields
  }
}
    ${UserSettingFieldsFragmentDoc}`;

export function useCreateUserSettingsMutation() {
  return Urql.useMutation<CreateUserSettingsMutation, CreateUserSettingsMutationVariables>(CreateUserSettingsDocument);
};
export const UpdateUserSettingsDocument = gql`
    mutation updateUserSettings($setting: JSON!, $name: String!) {
  updateUserSetting(
    userSettingUpdateData: {setting: $setting, name: $name, updatedBy: {name: "dashboard"}}
  ) {
    ...UserSettingFields
  }
}
    ${UserSettingFieldsFragmentDoc}`;

export function useUpdateUserSettingsMutation() {
  return Urql.useMutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(UpdateUserSettingsDocument);
};
export const GetVideosDocument = gql`
    query getVideos($locale: String!) {
  videos {
    youtube {
      latest(input: {locale: $locale}) {
        ...YoutubeVideoSectionFields
      }
      doItYourself(input: {locale: $locale}) {
        ...YoutubeVideoSectionFields
      }
      gardening(input: {locale: $locale}) {
        ...YoutubeVideoSectionFields
      }
      forProfessionals(input: {locale: $locale}) {
        ...YoutubeVideoSectionFields
      }
    }
  }
}
    ${YoutubeVideoSectionFieldsFragmentDoc}`;

export function useGetVideosQuery(options: Omit<Urql.UseQueryArgs<GetVideosQueryVariables>, 'query'>) {
  return Urql.useQuery<GetVideosQuery, GetVideosQueryVariables>({ query: GetVideosDocument, ...options });
};